<template>
  <div class="mb-4">
    <div
      v-if="
        loadedMatrixPOI &&
        loadedMatrixAreas &&
        loadedMatrixForVROOM &&
        omekaIDsLoaded
      "
    >
      <div class="row">
        <div
          class="col-12 pr-0"
          :class="isLarge ? 'div_header' : 'div_header_mobile'"
        >
          <i
            class="bi bi-arrow-left ml-3 goBackArrow pt-3"
            v-on:click="goBack()"
          ></i>
          <h4><b>Creazione itinerario</b></h4>
        </div>
      </div>

      <!-- <div class="row text-right">
        <div
          class="col-12"
        >
                    <a class="btn-create-itinerary_not_floating mr-3">
ì                <svg height="40" width="160">
                  <text x="10" y="0" style="font-weight: bold">
                    <tspan x="28" y="23">Crea Itinerario</tspan>
                  </text>
                </svg>
              </a>
        </div>
      </div> -->

      <div>
        <div class="row px-3">
          <div class="col-lg-4" :class="!isLarge ? 'px-2' : 'border-right'">
            <h5 class="mb-0"><b>Tempo a disposizione rimanente</b></h5>
            <h6>
              {{ msToTime.hours }}
              <template v-if="msToTime.hours === '01'"> ora</template>
              <template v-else> ore</template>

              <template v-if="msToTime.minutes !== '00'">
                e {{ msToTime.minutes }} minuti</template
              >
            </h6>

            <i class="card-title text-center">
              Il tempo occupato include gli spostamenti da luogo a luogo e i
              tempi per l'organizzazione delle attività
            </i>

            <div
              class="collapsible"
              @click="openAreasCollapse"
              id="selezionaAreaCollapse"
            >
              <h5 class="mb-0 mt-2">
                <b>Seleziona un'area</b>
                <i v-if="areasCollapseIsOpen" class="bi bi-arrow-up-short"></i>
                <i v-else class="bi bi-arrow-down-short"></i>
              </h5>
            </div>
            <div
              :class="areasCollapseIsOpen ? 'content-open' : 'content-close'"
              v-if="areasWithSomePOIinside.length > 0"
            >
              <n-radio
                v-for="(area, index) in areasWithSomePOIinside"
                :key="index"
                v-model="$store.state.selectedAreaCreateItinerary"
                :label="area['o:title']"
                @input="checkArea(index, area['o:title'])"
                :name="area['o:title']"
              >
                {{ area["o:title"] }}
              </n-radio>
            </div>
            <div v-else>
              <div class="loader_filter">
                <svg class="circular">
                  <circle
                    class="path"
                    cx="50"
                    cy="50"
                    r="20"
                    fill="none"
                    stroke-width="5"
                    stroke-miterlimit="10"
                  ></circle>
                </svg>
              </div>
            </div>

            <div
              class="collapsible"
              @click="openInterestsCollapse"
              id="selezionaAreaCollapse"
            >
              <h5 class="mb-0 mt-3">
                <b>{{ getInterestsCollapseTitle() }}</b>
                <i
                  v-if="interestsCollapseIsOpen"
                  class="bi bi-arrow-up-short"
                ></i>
                <i v-else class="bi bi-arrow-down-short"></i>
              </h5>
            </div>
            <div
              :class="
                interestsCollapseIsOpen ? 'content-open' : 'content-close'
              "
              v-if="interestsLoaded"
            >
              <div class="row mt-3">
                <div class="col-12">
                  <Button
                    v-if="!selectAllInterests"
                    size="small"
                    type="primary"
                    v-on:click="selectAllInterestsFunctions()"
                    class="m-1"
                    >Seleziona tutto
                  </Button>
                  <Button
                    v-if="selectAllInterests"
                    size="small"
                    type="primary"
                    v-on:click="selectAllInterestsFunctions()"
                    class="m-1"
                    >Deseleziona tutto
                  </Button>
                </div>
              </div>
              <div class="mt-2 filterDiv">
                <n-checkbox
                  v-for="(item, index) in firstThreeInterests"
                  :key="'firstInterest' + index"
                  v-model="item.interestSelected"
                  @input="checkInterest(index, item.interestName)"
                >
                  {{ item.interestName }}
                </n-checkbox>

                <hr />

                <n-checkbox
                  v-for="(item, index) in remainingInterests"
                  :key="'interest' + index"
                  v-model="item.interestSelected"
                  @input="checkInterest(index, item.interestName)"
                >
                  {{ item.interestName }}
                </n-checkbox>
              </div>
            </div>
            <div v-else>
              <div class="loader_filter">
                <svg class="circular">
                  <circle
                    class="path"
                    cx="50"
                    cy="50"
                    r="20"
                    fill="none"
                    stroke-width="5"
                    stroke-miterlimit="10"
                  ></circle>
                </svg>
              </div>
            </div>

            <div
              class="collapsible"
              @click="openDifficultiesCollapse"
              id="selezionaDifficultyCollapse"
            >
              <h5 class="mb-0 mt-4">
                <b>Difficoltà attività</b>
                <i
                  v-if="difficultiesCollapseIsOpen"
                  class="bi bi-arrow-up-short"
                ></i>
                <i v-else class="bi bi-arrow-down-short"></i>
              </h5>
            </div>
            <div
              :class="
                difficultiesCollapseIsOpen ? 'content-open' : 'content-close'
              "
              v-if="difficultyLevelsLoaded"
            >
              <div class="mt-2 filterDiv">
                <n-radio
                  v-for="(item, index) in this.$store.state.expertiseLevels"
                  :key="'difficulty' + index"
                  v-model="$store.state.selectedDifficultyFilter"
                  :label="item.expertiseLevelName"
                  @input="checkDifficulty(index, item.expertiseLevelName)"
                >
                  <div class="row">
                    <div class="col-12">
                      {{ item.expertiseLevelName }}
                      <!--(-->
                      <!-- <svgScuolaInfanzia
                                      v-if="
                                        item.expertiseLevelName ===
                                        'Scuola dell\'Infanzia'
                                      "
                                    />
                                    <svgScuolaPrimaria
                                      v-if="
                                        item.expertiseLevelName ===
                                        'Scuola Primaria'
                                      "
                                    />
                                    <svgScuolaSecondariaPrimoGrado
                                      v-if="
                                        item.expertiseLevelName ===
                                        'Scuola Secondaria di Primo Grado'
                                      "
                                    />
                                    <svgScuolaSecondariaSecondoGrado
                                      v-if="
                                        item.expertiseLevelName ===
                                        'Scuola Secondaria di Secondo Grado'
                                      "
                                    />
                                    <svgUniversita
                                      v-if="
                                        item.expertiseLevelName === 'Università'
                                      "
                                    />
                                    <svgPerTutti
                                      v-if="
                                        item.expertiseLevelName === 'Per Tutti'
                                      "
                                    /> -->
                    </div>
                  </div>
                </n-radio>
              </div>
            </div>
            <div v-else>
              <div class="loader_filter">
                <svg class="circular">
                  <circle
                    class="path"
                    cx="50"
                    cy="50"
                    r="20"
                    fill="none"
                    stroke-width="5"
                    stroke-miterlimit="10"
                  ></circle>
                </svg>
              </div>
            </div>

            <div
              class="collapsible"
              @click="openActivityTypesCollapse"
              id="selezionaActivityTypeCollapse"
            >
              <h5 class="mb-0 mt-4">
                <b> {{ getActivityTypeCollapseTitle() }}</b>
                <i
                  v-if="activityTypeCollapseIsOpen"
                  class="bi bi-arrow-up-short"
                ></i>
                <i v-else class="bi bi-arrow-down-short"></i>
              </h5>
            </div>
            <div
              :class="
                activityTypeCollapseIsOpen ? 'content-open' : 'content-close'
              "
              v-if="activityTypeLoaded"
            >
              <div class="mt-2 filterDiv">
                <div class="row mt-3">
                  <div class="col-12">
                    <Button
                      v-if="!selectAllActivityType"
                      size="small"
                      type="primary"
                      v-on:click="selectAllActivityTypeFunctions()"
                      class="m-1"
                      >Seleziona tutto
                    </Button>
                    <Button
                      v-if="selectAllActivityType"
                      size="small"
                      type="primary"
                      v-on:click="selectAllActivityTypeFunctions()"
                      class="m-1"
                      >Deseleziona tutto
                    </Button>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <div class="mt-2 filterDiv">
                      <div class="form-radio text-left px-1">
                        <n-checkbox
                          v-for="(item, index) in this.$store.state
                            .activityType"
                          :key="'activityType' + index"
                          v-model="item.activityTypeSelected"
                          @input="
                            checkActivityType(index, item.activityTypeName)
                          "
                        >
                          {{ item.activityTypeName }}
                        </n-checkbox>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="loader_filter">
                <svg class="circular">
                  <circle
                    class="path"
                    cx="50"
                    cy="50"
                    r="20"
                    fill="none"
                    stroke-width="5"
                    stroke-miterlimit="10"
                  ></circle>
                </svg>
              </div>
            </div>
            <!-- 
            <div v-if="$store.getters.viewFeaturesProgettoTesi">
              <div class="row mb-2">
                <div class="col-12">
                  <n-checkbox v-model="restaurantsVisibleOnMap">
                    Visualizza ristoranti sulla mappa
                  </n-checkbox>
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-12">
                  <n-checkbox v-model="barsVisibleOnMap">
                    Visualizza bar sulla mappa
                  </n-checkbox>
                </div>
              </div>
            </div> -->

            <div class="row mt-4">
              <div class="col-lg-12">
                <h5
                  class="mt-0"
                  :class="{
                    'mobile-subtitle': !isLarge,
                  }"
                >
                  <b>Attività selezionate</b>
                </h5>

                <Button
                  class="mb-3"
                  type="danger"
                  v-if="this.$store.getters.activitiesSelectedList.length > 0"
                  @click="removeAllActivities()"
                  ><i class="bi bi-trash trash-icon"></i> Rimuovi tutto</Button
                >

                <elencoAttivitaSelezionate
                  @changeSelection="changeSelection"
                  @changeSelectionVisitPOI="changeSelectionVisitPOI"
                />

                <div v-if="someActivitiesSelected" class="mb-2"></div>
                <div v-else class="mb-2">Nessuna attività selezionata</div>
              </div>
            </div>
          </div>

          <div class="col-lg-8">
            <div class="row">
              <div class="col-lg-12">
                <div class="row">
                  <div class="col-7 px-0 ml-2 mb-2 aree__tagbox">
                    <button
                      :class="
                        selectedTab === 'ElencoPercorsi'
                          ? 'tag__item__selected'
                          : 'tag__item__unselected'
                      "
                      v-on:click="selectedTab = 'ElencoPercorsi'"
                    >
                      Visualizza i luoghi e le attività
                    </button>
                    <button
                      :class="
                        selectedTab === 'Mappa'
                          ? 'tag__item__selected'
                          : 'tag__item__unselected'
                      "
                      v-on:click="selectedTab = 'Mappa'"
                    >
                      Visualizza Mappa
                    </button>
                  </div>
                  <div
                    class="col-4 ml-lg-5 text-right"
                    style="
                      margin: 20px 0 0 0;
                      padding: 0;
                      justify-content: flex-start;
                    "
                    v-if="this.$store.getters.activitiesSelectedList.length > 0"
                  >
                    <span
                      class="btn-create-itinerary_not_floating"
                      v-on:click="incrementStep()"
                    >
                      <svg height="40" width="120">
                        <text x="10" y="0" style="font-weight: bold">
                          <tspan x="8" y="23">Crea Itinerario</tspan>
                        </text>
                      </svg>
                    </span>
                    <!-- <button
                      :class="
                        selectedTab === 'Mappa'
                          ? 'tag__item__selected'
                          : 'tag__item__unselected'
                      "
                      v-on:click="selectedTab = 'Mappa'"
                    >
                      Visualizza Mappa
                    </button> -->
                  </div>
                </div>

                <div class="row">
                  <div
                    class="col-lg-12"
                    v-if="selectedTab === 'ElencoPercorsi'"
                  >
                    <div
                      class="row"
                      v-if="
                        numberOfResultVisibleWithFiltersInSelectedArea[
                          $store.getters.selectedAreaCreateItinerary
                        ]
                      "
                    >
                      <div class="col-12" :class="!isLarge ? 'px-2' : ''">
                        <h5
                          class="mt-0"
                          :class="{
                            'mobile-subtitle': !isLarge,
                          }"
                        >
                          <b
                            >Luoghi e attività nell'area:
                            {{ $store.getters.selectedAreaCreateItinerary }} ({{
                              numberOfResultVisibleWithFiltersInSelectedArea[
                                $store.getters.selectedAreaCreateItinerary
                              ][0]
                            }}
                            <template
                              v-if="
                                numberOfResultVisibleWithFiltersInSelectedArea[
                                  $store.getters.selectedAreaCreateItinerary
                                ][0] !== 1
                              "
                              >luoghi</template
                            >
                            <template v-else>luogo</template>,
                            {{
                              numberOfResultVisibleWithFiltersInSelectedArea[
                                $store.getters.selectedAreaCreateItinerary
                              ][1]
                            }}
                            attività)
                          </b>
                        </h5>
                        <div>
                          <div v-if="isLarge" class="mb-3">
                            <i
                              class="bi bi-circle-fill activityAvailableInTime"
                            ></i>
                            Attività selezionabile <br />
                            <i
                              class="bi bi-circle-fill activityNotAvailableInTime"
                            ></i>
                            Attività non selezionabile nel tempo a disposizione
                          </div>
                          <div v-else class="mb-3">
                            <div class="row">
                              <div class="col-1">
                                <i
                                  class="bi bi-circle-fill activityAvailableInTime"
                                ></i>
                              </div>
                              <div class="col-11">Attività selezionabile</div>
                            </div>
                            <div class="row">
                              <div class="col-1">
                                <i
                                  class="bi bi-circle-fill activityNotAvailableInTime"
                                ></i>
                              </div>
                              <div class="col-11">
                                Attività non selezionabile nel tempo a
                                disposizione
                              </div>
                            </div>
                          </div>
                          <div v-if="poiLoaded">
                            <div
                              v-if="
                                somePOIVisibleInCurrentArea &&
                                this.$store.state.allActivitiesLoaded
                              "
                            >
                              <div
                                v-for="(item, index) in this.filteredPOI"
                                :key="'filteredPOI' + (index + 300)"
                              >
                                <article
                                  class="postcard light white"
                                  v-if="
                                    $store.getters
                                      .selectedAreaCreateItinerary ===
                                      item['geo:appartiene_a_area'][0][
                                        'display_title'
                                      ] && item.poiVisibleWithFilters
                                  "
                                >
                                  <a class="postcard__img_link">
                                    <!-- se si vogliono le immagini cliccabili: v-img="{ group: getGroupName(item) }"-->
                                    <img
                                      v-if="item.media && item.media.length > 0"
                                      class="postcard__img"
                                      :src="
                                        item['media'][0]['o:thumbnail_urls'][
                                          'large'
                                        ]
                                      "
                                      :alt="item['geo:Titolo_it'][0]['@value']"
                                    />
                                    <img
                                      v-else
                                      class="postcard__img"
                                      src="@/assets/images/default.png"
                                      :alt="item['geo:Titolo_it'][0]['@value']"
                                    />
                                  </a>
                                  <div class="postcard__text">
                                    <div class="row px-0">
                                      <div
                                        :class="isLarge ? 'col-7' : 'col-12'"
                                        class="mx-0 px-0"
                                      >
                                        <h1
                                          class="postcard__title ml-3"
                                          :class="!isLarge ? 'text-center' : ''"
                                        >
                                          <a>{{
                                            item["geo:Titolo_it"][0]["@value"]
                                          }}</a>
                                        </h1>
                                      </div>
                                      <div class="col-5 px-0">
                                        <ul
                                          class="postcard__tagbox mx-3"
                                          v-if="isLarge"
                                          style="justify-content: right"
                                        >
                                          <li
                                            :class="
                                              item.visitPOI
                                                ? 'tag__item__unselected'
                                                : 'tag__item__selected'
                                            "
                                            v-on:click="
                                              visitPlaceClicked(
                                                item['geo:Titolo_it'][0][
                                                  '@value'
                                                ]
                                              )
                                            "
                                          >
                                            <template v-if="!item.visitPOI"
                                              >+ Aggiungi la visita del
                                              luogo</template
                                            >
                                            <template v-else
                                              ><i
                                                class="bi bi-trash trash-icon"
                                              ></i>
                                              - Rimuovi la visita del
                                              luogo</template
                                            >
                                          </li>
                                        </ul>
                                      </div>
                                    </div>

                                    <div
                                      class="row text-center"
                                      v-if="!isLarge"
                                    >
                                      <div class="col-12">
                                        <ul
                                          class="postcard__tagbox mx-3"
                                          style="justify-content: center"
                                        >
                                          <li
                                            :class="
                                              item.visitPOI
                                                ? 'tag__item__unselected'
                                                : 'tag__item__selected'
                                            "
                                            v-on:click="
                                              visitPlaceClicked(
                                                item['geo:Titolo_it'][0][
                                                  '@value'
                                                ]
                                              )
                                            "
                                          >
                                            <template v-if="!item.visitPOI"
                                              >+ Aggiungi la visita del
                                              luogo</template
                                            >
                                            <template v-else
                                              ><i
                                                class="bi bi-trash trash-icon"
                                              ></i>
                                              - Rimuovi la visita del
                                              luogo</template
                                            >
                                          </li>
                                        </ul>
                                      </div>
                                    </div>

                                    <!-- <div class="postcard__bar"></div> -->
                                    <div
                                      class="postcard__preview-txt"
                                      v-if="item['dcterms:description']"
                                    >
                                      {{
                                        item["dcterms:description"][0]["@value"]
                                      }}
                                    </div>
                                    <div class="postcard__preview-txt" v-else>
                                      Descrizione non disponibile
                                    </div>

                                    <div
                                        v-for="(link, index) in item['geo:Scheda_esterna']"
                                        :key="link['@value']"
                                        class="postcard__preview-txt mt-2"
                                        :class="index === 0 ? 'mt-3' : 'mt-1'"
                                        style="max-height: 100px; overflow: scroll"
                                    >
                                      <a :href="getLink(link['@value'])" target="_blank"  style="color: #5486a8 !important;">{{getLinkName(link['@value'])}}</a>
                                    </div>
                                    <!--<div
                                      class="postcard__preview-txt mt-2"
                                      v-if="item['geo:Scheda_esterna']"
                                    >
                                      <a
                                        :href="
                                          item['geo:Scheda_esterna'][0][
                                            '@value'
                                          ]
                                        "
                                        >Dettagli
                                        </a
                                      >
                                    </div>-->

                                    <div
                                      class="mt-3"
                                      v-if="item['geo:ha_interesse']"
                                    >
                                      <h6>
                                        <template
                                          v-if="
                                            getInterestList(
                                              item['geo:ha_interesse'],
                                              item
                                            ).length > 1
                                          "
                                          >Interessi:
                                        </template>
                                        <template v-else>Interesse: </template>
                                        <span class="font-weight-normal">{{
                                          getInterestList(
                                            item["geo:ha_interesse"],
                                            item
                                          ).join(", ")
                                        }}</span>
                                      </h6>
                                    </div>

                                    <div v-if="isLarge">
                                      <ul
                                        class="postcard__tagbox my-2"
                                        style="justify-content: left"
                                      >
                                        <li class="tag__item__title mr-3">
                                          <i class="bi bi-clock mr-2"></i>
                                          Tempo di visita:

                                          <template
                                            v-if="
                                              item['geo:Durata'] !== undefined
                                            "
                                            >{{
                                              item["geo:Durata"][0]["@value"]
                                            }}
                                            minuti
                                          </template>
                                          <template v-else>10 minuti</template>
                                          <i
                                            v-if="!item.visitPOI"
                                            class="bi bi-circle-fill"
                                            :class="
                                              parseInt(
                                                item['geo:Durata'][0]['@value']
                                              ) *
                                                60000 <=
                                              msToTime.milliseconds
                                                ? 'activityAvailableInTime'
                                                : 'activityNotAvailableInTime'
                                            "
                                          ></i>
                                        </li>
                                        <!-- <li
                                          :class="
                                            item.visitPOI
                                              ? 'tag__item__unselected'
                                              : 'tag__item__selected'
                                          "
                                          v-on:click="
                                            visitPlaceClicked(
                                              item['geo:Titolo_it'][0]['@value']
                                            )
                                          "
                                        >
                                          <template v-if="!item.visitPOI"
                                            >+ Aggiungi la visita del
                                            luogo</template
                                          >
                                          <template v-else
                                            ><i
                                              class="bi bi-trash trash-icon"
                                            ></i>
                                            - Rimuovi la visita del luogo</template
                                          >
                                        </li> -->
                                      </ul>
                                    </div>
                                    <div v-else>
                                      <div class="col-12 my-2 text-center">
                                        Tempo di visita:

                                        <template
                                          v-if="
                                            item['geo:Durata'] !== undefined
                                          "
                                          >{{ item["geo:Durata"][0]["@value"] }}
                                          minuti
                                        </template>
                                        <template v-else>10 minuti</template>
                                        <i
                                          v-if="!item.visitPOI"
                                          class="bi bi-circle-fill"
                                          :class="
                                            parseInt(
                                              item['geo:Durata'][0]['@value']
                                            ) *
                                              60000 <=
                                            msToTime.milliseconds
                                              ? 'activityAvailableInTime'
                                              : 'activityNotAvailableInTime'
                                          "
                                        ></i>
                                      </div>
                                      <!-- <div class="row">
                                        <div class="col-12 text-center">
                                          <ul class="postcard__tagbox">
                                            <li
                                              :class="
                                                item.visitPOI
                                                  ? 'tag__item__unselected'
                                                  : 'tag__item__selected'
                                              "
                                              v-on:click="
                                                visitPlaceClicked(
                                                  item['geo:Titolo_it'][0][
                                                    '@value'
                                                  ]
                                                )
                                              "
                                            >
                                              <template v-if="!item.visitPOI"
                                                >+ Aggiungi la visita visita del
                                                luogo</template
                                              >
                                              <template v-else
                                                ><i
                                                  class="bi bi-trash trash-icon"
                                                ></i>
                                                - Rimuovi la visita del luogo</template
                                              >
                                            </li>
                                          </ul>
                                        </div>
                                      </div> -->
                                    </div>
                                    <div
                                      v-if="
                                        item['mis'].length > 0 &&
                                        item.poiHasSomeActivitiesVisible
                                      "
                                    >
                                      <collapse>
                                        <collapse-item
                                          :title="
                                            getAddActivitiesCollapseTitle(item)
                                          "
                                          name="1"
                                          class="mt-2 mb-0"
                                        >
                                          <div v-if="item.mis.length > 0">
                                            <div
                                              v-for="(it, ind) in item.mis"
                                              :key="
                                                'filteredPOIactivities' +
                                                (ind + 300)
                                              "
                                              class="pl-3"
                                            >
                                              <div
                                                v-if="
                                                  it.activityVisibleWithDifficultiesFilters &&
                                                  it.activityVisibleWithInterestsFilters &&
                                                  it.activityVisibleWithActivityTypeFilters
                                                "
                                              >
                                                <div
                                                  class="row mt-0 py-2 text-center align-items-center"
                                                >
                                                  <div class="col-12 pl-0">
                                                    <div class="mt-3">
                                                      <div class="row">
                                                        <div
                                                          class="col-12 text-left"
                                                        >
                                                          <h6>
                                                            {{ it["o:title"] }}
                                                            <!-- <i
                                                              class="
                                                                ml-2
                                                                mt-3
                                                                bi
                                                                bi-info-circle
                                                                mr-2
                                                              "
                                                            ></i> -->
                                                          </h6>
                                                        </div>
                                                      </div>

                                                      <div
                                                        class="row text-left"
                                                      >
                                                        <div
                                                          :class="
                                                            isLarge
                                                              ? 'col-9'
                                                              : 'col-12'
                                                          "
                                                        >
                                                          <i
                                                            class="bi bi-clock mr-2"
                                                          ></i>
                                                          {{
                                                            it["geo:Durata"][0][
                                                              "@value"
                                                            ]
                                                          }}
                                                          minuti +
                                                          <template
                                                            v-if="
                                                              it[
                                                                'geo:Durata_organizzazione'
                                                              ] !== undefined
                                                            "
                                                            >{{
                                                              it[
                                                                "geo:Durata_organizzazione"
                                                              ][0]["@value"]
                                                            }}</template
                                                          >
                                                          <template
                                                            v-else-if="omekaIDs"
                                                            >{{
                                                              omekaIDs.defaultOrganizationTime
                                                            }}</template
                                                          >

                                                          minuti di
                                                          organizzazione

                                                          <i
                                                            v-if="!it.selected"
                                                            class="bi bi-circle-fill"
                                                            :class="
                                                              checkDuration(it)
                                                                ? 'activityAvailableInTime'
                                                                : 'activityNotAvailableInTime'
                                                            "
                                                          ></i>
                                                        </div>
                                                        <div
                                                          :class="
                                                            isLarge
                                                              ? 'col-3'
                                                              : 'col-12 my-3'
                                                          "
                                                        >
                                                          <ul
                                                            class="activity__tagbox"
                                                            :class="{
                                                              'float-right':
                                                                isLarge,
                                                              'text-center ':
                                                                !isLarge,
                                                            }"
                                                          >
                                                            <li
                                                              v-if="it.selected"
                                                              class="tag__item__unselected"
                                                              v-on:click="
                                                                changeSelection(
                                                                  item[
                                                                    'geo:Titolo_it'
                                                                  ][0][
                                                                    '@value'
                                                                  ],
                                                                  it['o:title']
                                                                )
                                                              "
                                                            >
                                                              <i
                                                                class="bi bi-trash trash-icon"
                                                              ></i>
                                                              - Rimuovi attività
                                                            </li>
                                                            <li
                                                              v-else
                                                              class="tag__item__selected"
                                                              v-on:click="
                                                                changeSelection(
                                                                  item[
                                                                    'geo:Titolo_it'
                                                                  ][0][
                                                                    '@value'
                                                                  ],
                                                                  it['o:title']
                                                                )
                                                              "
                                                            >
                                                              + Aggiungi
                                                              attività
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>

                                                      <div
                                                        class="row text-left"
                                                      >
                                                        <div
                                                          class="col-12 font-italic"
                                                        >
                                                          Livello di difficoltà:

                                                          <template
                                                            v-if="
                                                              it[
                                                                'geo:ha_difficolta'
                                                              ][0][
                                                                'display_title'
                                                              ] !== 'Per Tutti'
                                                            "
                                                          >
                                                            <b
                                                              >da
                                                              {{
                                                                it[
                                                                  "geo:ha_difficolta"
                                                                ][0][
                                                                  "display_title"
                                                                ]
                                                              }}
                                                              in su</b
                                                            >
                                                          </template>
                                                          <template v-else>
                                                            <b>{{
                                                              it[
                                                                "geo:ha_difficolta"
                                                              ][0][
                                                                "display_title"
                                                              ]
                                                            }}</b>
                                                          </template>
                                                        </div>
                                                      </div>

                                                      <div
                                                        class="row text-left"
                                                      >
                                                        <div
                                                          class="col-12"
                                                          v-if="
                                                            it[
                                                              'geo:ha_tipologia_attivita'
                                                            ]
                                                          "
                                                        >
                                                          Tipologia:
                                                          {{
                                                            it[
                                                              "geo:ha_tipologia_attivita"
                                                            ][0][
                                                              "display_title"
                                                            ]
                                                          }}
                                                        </div>
                                                        <div
                                                          class="col-12"
                                                          v-else
                                                        >
                                                          Tipologia: Non
                                                          disponibile
                                                        </div>
                                                      </div>

                                                      <div
                                                        class="row mt-3 text-left"
                                                      >
                                                        <div
                                                          class="col-12"
                                                          v-if="
                                                            it[
                                                              'geo:ha_tipologia_attivita'
                                                            ]
                                                          "
                                                        >
                                                          <h6>
                                                            <template
                                                              v-if="
                                                                getInterestListActivity(
                                                                  it[
                                                                    'geo:ha_interesse'
                                                                  ]
                                                                ).length > 1
                                                              "
                                                              >Interessi:
                                                            </template>
                                                            <template v-else
                                                              >Interesse:
                                                            </template>
                                                            <span
                                                              class="font-weight-normal"
                                                              >{{
                                                                getInterestListActivity(
                                                                  it[
                                                                    "geo:ha_interesse"
                                                                  ]
                                                                ).join(", ")
                                                              }}</span
                                                            >
                                                          </h6>
                                                        </div>
                                                      </div>

                                                      <div
                                                        class="mt-2 row text-left"
                                                      >
                                                        <div class="col-12">
                                                          <collapse>
                                                            <collapse-item
                                                              title="Più dettagli"
                                                            >
                                                              <div
                                                                class="font-weight-normal pb-0 activity-description"
                                                              >
                                                                {{
                                                                  it[
                                                                    "dcterms:description"
                                                                  ][0]["@value"]
                                                                }}
                                                              </div>
                                                            </collapse-item>
                                                          </collapse>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <!-- <div class="col-lg-3 col-12">
                                                    <ul
                                                      class="activity__tagbox"
                                                      :class="{
                                                        'float-right': isLarge,
                                                        'text-center mb-3':
                                                          !isLarge,
                                                      }"
                                                    >
                                                      <li
                                                        v-if="it.selected"
                                                        class="
                                                          tag__item__unselected
                                                        "
                                                        v-on:click="
                                                          changeSelection(
                                                            item[
                                                              'geo:Titolo_it'
                                                            ][0]['@value'],
                                                            it['o:title']
                                                          )
                                                        "
                                                      >
                                                        <i
                                                          class="
                                                            bi bi-trash
                                                            trash-icon
                                                          "
                                                        ></i>
                                                        - Rimuovi attività
                                                      </li>
                                                      <li
                                                        v-else
                                                        class="
                                                          tag__item__selected
                                                        "
                                                        v-on:click="
                                                          changeSelection(
                                                            item[
                                                              'geo:Titolo_it'
                                                            ][0]['@value'],
                                                            it['o:title']
                                                          )
                                                        "
                                                      >
                                                        + Aggiungi attività
                                                      </li>
                                                    </ul>
                                                  </div> -->

                                                  <hr
                                                    v-if="
                                                      ind < item.mis.length - 1
                                                    "
                                                    class="w-100 text-center my-0 py-0"
                                                  />
                                                </div>
                                              </div>
                                              <!-- <div v-else>
                                                Sono qua
                                              </div> -->
                                              <!-- v-else l'attività non è visibile -->
                                            </div>
                                          </div>
                                          <!-- <div v-else>
                                          Non ci sono attività disponibili in
                                          questo luogo
                                        </div> -->
                                        </collapse-item>
                                      </collapse>
                                    </div>
                                    <div v-else class="my-1">
                                      Non ci sono attività disponibili in questo
                                      luogo
                                    </div>
                                  </div>
                                </article>
                              </div>
                            </div>
                            <div
                              v-else-if="
                                this.filteredPOI === null ||
                                this.filteredPOI === undefined ||
                                filteredPOI.length === 0
                              "
                            >
                              <h4
                                slot="header"
                                class="title title-up text-center"
                              >
                                Caricamento in corso
                              </h4>
                              <div class="loader mt-3">
                                <svg class="circular">
                                  <circle
                                    class="path"
                                    cx="50"
                                    cy="50"
                                    r="20"
                                    fill="none"
                                    stroke-width="5"
                                    stroke-miterlimit="10"
                                  ></circle>
                                </svg>
                              </div>
                            </div>
                            <div v-else>
                              Nessuna attività o luogo corrispondente ai filtri
                              selezionati nella zona
                              <b
                                v-if="
                                  $store.getters.selectedAreaCreateItinerary !==
                                  null
                                "
                                >{{
                                  $store.getters.selectedAreaCreateItinerary.toUpperCase()
                                }}</b
                              >
                            </div>
                          </div>
                          <div v-else>
                            <div class="loader_filter mt-5">
                              <svg class="circular">
                                <circle
                                  class="path"
                                  cx="50"
                                  cy="50"
                                  r="20"
                                  fill="none"
                                  stroke-width="5"
                                  stroke-miterlimit="10"
                                ></circle>
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-12" v-else>
                    <div class="row mb-5">
                      <div class="col-lg-12">
                        <!-- <h5 class="mt-0">
                          <b>Mappa</b>
                        </h5> -->
                        <h6 class="mt-0">
                          Per selezionare punti di interesse e attività clicca
                          su “Visualizza i luoghi e le attività”
                        </h6>
                        <div>
                          <l-map
                            :zoom="zoom"
                            :center="centerMap"
                            style="height: 700px; border-radius: 10px"
                          >
                            <l-tile-layer
                              :url="url"
                              :attribution="attribution"
                            ></l-tile-layer>
                            <l-marker
                              v-for="(marker, index) in markers"
                              :lat-lng="marker.marker.getLatLng()"
                              :key="'marker' + index"
                            >
                              <l-icon
                                v-if="marker.poiSelected"
                                :icon-url="
                                  require('../icons/inItineraryPOI.svg')
                                "
                              >
                              </l-icon>
                              <l-icon
                                v-if="!marker.poiSelected"
                                :icon-url="
                                  require('../icons/unselectedPOI.svg')
                                "
                              >
                              </l-icon>
                              <l-popup
                                :options="anchorOptions"
                                style="max-width: 250px"
                              >
                                <div class="px-3">
                                  <div class="row">
                                    <h5>{{ marker.POItitle }}</h5>
                                  </div>
                                  <div
                                    class="row text-justify"
                                    style="
                                      max-height: 100px;
                                      overflow-y: scroll;
                                    "
                                  >
                                    {{ marker.description }}
                                  </div>
                                  <div class="row mt-3">
                                    <div class="col-12 text-center">
                                      <img
                                        v-if="marker.image !== undefined"
                                        v-img="{ group: marker.POItitle }"
                                        class="margin-auto border-radius-5"
                                        :src="marker.image"
                                        :alt="marker.POItitle"
                                      />
                                      <img
                                        v-else
                                        v-img="{ group: marker.POItitle }"
                                        class="postcard__img border-radius-5"
                                        src="@/assets/images/default.png"
                                        :alt="marker.POItitle"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </l-popup>
                            </l-marker>

                            <!-- <div v-if="$store.getters.viewFeaturesProgettoTesi">
                              <div v-if="restaurantsVisibleOnMap">
                                <l-marker
                                  v-for="(marker, index) in restaurantsMarkers"
                                  :lat-lng="marker.marker.getLatLng()"
                                  :key="'restaurantsMarker' + index"
                                >
                                  <l-icon
                                    :icon-url="
                                      require('../icons/startPoint.png')
                                    "
                                  >
                                  </l-icon>
                                  <l-popup
                                    :options="anchorOptions"
                                    style="max-width: 250p; min-width: 130px"
                                  >
                                    <div class="px-3">
                                      <div class="row">
                                        <h5>{{ marker.POItitle }}</h5>
                                      </div>
                                      <div
                                        v-if="
                                          marker.street &&
                                          marker.housenumber &&
                                          marker.postcode
                                        "
                                        class="row text-justify"
                                        style="
                                          max-height: 100px;
                                          overflow-y: scroll;
                                        "
                                      >
                                        <b>Indirizzo: </b> &nbsp;
                                        {{ marker.street }},
                                        {{ marker.housenumber }} -
                                        {{ marker.postcode }}
                                      </div>
                                      <div
                                        v-if="marker.city"
                                        class="row text-justify"
                                        style="
                                          max-height: 100px;
                                          overflow-y: scroll;
                                        "
                                      >
                                        <b>Città: </b> &nbsp; {{ marker.city }}
                                      </div>
                                      <div
                                        v-if="marker.phone"
                                        class="row text-justify"
                                        style="
                                          max-height: 100px;
                                          overflow-y: scroll;
                                        "
                                      >
                                        <b>Contatti:</b> &nbsp;
                                        {{ marker.phone }}
                                      </div>
                                      <div class="row mt-3">
                                        <div class="col-12 text-center">
                                          <img
                                            v-img="{ group: marker.POItitle }"
                                            class="postcard__img border-radius-5"
                                            style="height: 100px"
                                            src="@/assets/images/restaurant.png"
                                            :alt="marker.POItitle"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </l-popup>
                                </l-marker>
                              </div>

                              <div v-if="barsVisibleOnMap">
                                <l-marker
                                  v-for="(marker, index) in barsMarkers"
                                  :lat-lng="marker.marker.getLatLng()"
                                  :key="'barsMarkers' + index"
                                >
                                  <l-icon
                                    :icon-url="
                                      require('../icons/selectedPOI.png')
                                    "
                                  >
                                  </l-icon>
                                  <l-popup
                                    :options="anchorOptions"
                                    style="max-width: 250px; min-width: 130px"
                                  >
                                    <div class="px-3">
                                      <div class="row">
                                        <h5>{{ marker.POItitle }}</h5>
                                      </div>
                                      <div
                                        v-if="
                                          marker.street &&
                                          marker.housenumber &&
                                          marker.postcode
                                        "
                                        class="row text-justify"
                                        style="
                                          max-height: 100px;
                                          overflow-y: scroll;
                                        "
                                      >
                                        <b>Indirizzo: </b> &nbsp;
                                        {{ marker.street }},
                                        {{ marker.housenumber }} -
                                        {{ marker.postcode }}
                                      </div>
                                      <div
                                        v-if="marker.city"
                                        class="row text-justify"
                                        style="
                                          max-height: 100px;
                                          overflow-y: scroll;
                                        "
                                      >
                                        <b>Città: </b> &nbsp; {{ marker.city }}
                                      </div>
                                      <div
                                        v-if="marker.phone"
                                        class="row text-justify"
                                        style="
                                          max-height: 100px;
                                          overflow-y: scroll;
                                        "
                                      >
                                        <b>Contatti:</b> &nbsp;
                                        {{ marker.phone }}
                                      </div>
                                      <div class="row mt-3">
                                        <div class="col-12 text-center">
                                          <img
                                            v-img="{ group: marker.POItitle }"
                                            class="postcard__img border-radius-5"
                                            style="height: 100px"
                                            src="@/assets/images/restaurant.png"
                                            :alt="marker.POItitle"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </l-popup>
                                </l-marker>
                              </div>
                            </div> -->

                            <l-control>
                              <div class="legend">
                                <h4>Legenda</h4>
                                <i style="background: #fce63c"></i
                                ><span>Luogo in itinerario</span><br />
                                <i style="background: #437fc5"></i
                                ><span>Luogo non in itinerario</span><br />
                              </div>
                            </l-control>
                          </l-map>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <modal
        :show.sync="modals.featureDevelopment"
        headerClasses="justify-content-center"
        @close="modals.featureDevelopment = false"
      >
        <h4 slot="header" class="title title-up text-center">Attenzione!</h4>
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-12 text-center">
                <h6 class="itineraryCode">
                  Seleziona almeno una delle attività proposte oppure esplora
                  uno degli itinerari proposti da noi!
                </h6>
                <Button
                  size="small"
                  type="primary"
                  v-on:click="goToItinerariPredefinitiPage()"
                  class="mx-1 mt-4"
                  >Esplora gli itinerari proposti da noi
                </Button>
              </div>
            </div>
          </div>
        </div>

        <template slot="footer">
          <Button
            size="small"
            type="danger"
            v-on:click="modals.featureDevelopment = false"
            class="mx-1"
            >Chiudi
          </Button>
        </template>
      </modal>

      <modal
        :show.sync="modals.errorGettingSottoitinerario"
        headerClasses="justify-content-center"
        @close="modals.errorGettingSottoitinerario = false"
      >
        <h4 slot="header" class="title title-up text-center">Errore!</h4>
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-12 text-center">
                <h6 class="itineraryCode">
                  Si è verificato un errore nella creazione del tuo itinerario,
                  riprova più tardi.
                </h6>
              </div>
            </div>
          </div>
        </div>

        <template slot="footer">
          <Button
            size="small"
            type="danger"
            v-on:click="modals.errorGettingSottoitinerario = false"
            class="mx-1"
            >Chiudi
          </Button>
        </template>
      </modal>

      <modal
        :show.sync="modals.loadingVROOMresponse"
        headerClasses="justify-content-center"
        @close="modals.loadingVROOMresponse = false"
      >
        <h4 slot="header" class="title title-up text-center">
          Caricamento in corso
        </h4>
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-12 text-center">
                <svg class="circular">
                  <circle
                    class="path"
                    cx="50"
                    cy="50"
                    r="20"
                    fill="none"
                    stroke-width="5"
                    stroke-miterlimit="10"
                  ></circle>
                </svg>
              </div>
            </div>
          </div>
        </div>

        <template slot="footer">
          <Button
            size="small"
            type="danger"
            v-on:click="modals.loadingVROOMresponse = false"
            class="mx-1"
            >Chiudi
          </Button>
        </template>
      </modal>

      <modal
        :show.sync="modals.timeExceeded"
        headerClasses="justify-content-center"
        @close="modals.timeExceeded = false"
      >
        <h4 slot="header" class="title title-up text-center">Attenzione!</h4>
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-12 text-center">
                <h6 class="itineraryCode">
                  {{ errorMessage }}
                </h6>
              </div>
            </div>
          </div>
        </div>

        <template slot="footer">
          <Button
            size="small"
            type="danger"
            v-on:click="modals.timeExceeded = false"
            class="mx-1"
            >Chiudi
          </Button>
        </template>
      </modal>

      <modal
        :show.sync="modals.addActivityOrVisit"
        headerClasses="justify-content-center"
        @close="initVisitOrActivityMutex()"
      >
        <h4 slot="header" class="title title-up text-center">Attenzione!</h4>
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-12 text-center">
                <h6 class="itineraryCode">
                  La visita del luogo e l'attività non stanno entrambe nel tempo
                  a disposizione rimanente! Cosa vuoi aggiungere?
                </h6>
                <div
                  v-if="visitPOIMutex !== null"
                  class="row align-items-center"
                >
                  <div class="col-8">
                    Visita {{ visitPOIMutex["geo:Titolo_it"][0]["@value"] }}
                  </div>
                  <div class="col-4">
                    <ul class="select-button">
                      <li
                        class="tag__item__selected"
                        v-on:click="addVisitPOIMutex()"
                      >
                        <template>+ Aggiungi la visita del luogo</template>
                      </li>
                    </ul>
                  </div>
                </div>
                <div
                  v-if="activityMutex !== null"
                  class="row align-items-center"
                >
                  <div class="col-8">{{ activityMutex["o:title"] }}</div>
                  <div class="col-4">
                    <ul class="select-button">
                      <li
                        class="tag__item__selected"
                        v-on:click="addActivityMutex()"
                      >
                        <template>+ Aggiungi attività</template>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <template slot="footer">
          <Button
            size="small"
            type="danger"
            v-on:click="modals.addActivityOrVisit = false"
            class="mx-1"
            >Chiudi
          </Button>
        </template>
      </modal>
    </div>
    <div v-else>
      <h4 slot="header" class="title title-up text-center">
        Caricamento in corso
      </h4>
      <div class="loader">
        <svg class="circular">
          <circle
            class="path"
            cx="50"
            cy="50"
            r="20"
            fill="none"
            stroke-width="5"
            stroke-miterlimit="10"
          ></circle>
        </svg>
      </div>
    </div>
    <!-- <go-top :size="50" :bottom="50" :bg-color="'#f8823e'" :z-index="100" :tabindex="1"></go-top> -->
    <ScrollTopArrow
      v-on:create-itinerary="catchCreateItinerary()"
      :createItinerary="true"
    ></ScrollTopArrow>
  </div>
</template>

<script>
import ScrollTopArrow from "../components/customComponents/ScrollTopArrow";

import {
  LMap,
  LMarker,
  LPopup,
  LIcon,
  LTileLayer,
  LControl,
} from "vue2-leaflet";

import { Button } from "element-ui";
import { Checkbox, Collapse, CollapseItem, Radio, Modal } from "../components";
import "bootstrap-icons/font/bootstrap-icons.css";
import "leaflet.awesome-markers";
import "vue-collapsible-component/lib/vue-collapsible.css";
import store from "../store";
import * as L from "leaflet";
import router from "../router";
import $ from "jquery";
import elencoAttivitaSelezionate from "../components/customComponents/elencoAttivitaSelezionate";
import { config } from "../utils/config";
import { vsCollapse } from "vuesax";
import "../../src/assets/scss/vuesax.css";
import "material-icons/iconfont/material-icons.css";
import Vue from "vue";
Vue.use(vsCollapse);

const Common = require("@/Common.vue").default;

export default {
  name: "PercorsiNew",
  bodyClass: "percorsi-page",

  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LIcon,
    LControl,
    ScrollTopArrow,
    Modal,
    Button,
    [Radio.name]: Radio,
    [Checkbox.name]: Checkbox,
    Collapse,
    CollapseItem,
    elencoAttivitaSelezionate,
  },

  data() {
    return {
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 11,
      center: [45.47724690648075, 7.888264286334166],
      map: null,
      geojson: null,
      markers: [],
      windowWidth: 0,

      restaurantsMarkers: [],
      barsMarkers: [],

      filteredPOI: [], //array di POI filtrati con i filtri

      selectAllDifficulties: false, //variabile usata per selezionare/deselezionare tutte le difficoltà
      selectAllInterests: false, //variabile usata per selezionare/deselezionare tutti gli interessi
      selectAllActivityType: false, //variabile usata per selezionare/deselezionare tutte le tipologie di attività

      difficultyLevelsLoaded: false,
      interestsLoaded: false,
      activityTypeLoaded: false,

      selectedArea: null,

      modals: {
        //oggetto usato per mostrare i modals
        insertCodeModal: false,
        featureDevelopment: false,
        errorGettingSottoitinerario: false,
        loadingVROOMresponse: false,
        timeExceeded: false,
        addActivityOrVisit: false,
      },

      pathCodeInserted: "", //variabile usata per contenere il codice del percorso inserito dell'utente

      totalItinerary: [],

      anchorOptions: { offset: L.point(0, -30) },

      startPoint: [45.47561994860321, 7.889627627278735],
      endPoint: [45.47548295737901, 7.888970990326549],

      selectedTab: "ElencoPercorsi",

      timeBetweenAreas: 0,
      bestPathBetweenAreas: null,
      bestOldPath: [],
      oldTotalCostBetweenAreas: 0,

      lastActivityOrVisitSelected: {
        type: null, // type appartiene a {"Visit", "Activity"}
        name: null,
      },

      errorMessage: "",
      activityMutex: null,
      visitPOIMutex: null,
      omekaIDs: null,
      omekaIDsLoaded: false,
      poiLoaded: false,

      areasCollapseIsOpen: true,
      interestsCollapseIsOpen: true,
      difficultiesCollapseIsOpen: true,
      activityTypeCollapseIsOpen: true,

      restaurantsVisibleOnMap: true,
      barsVisibleOnMap: true,

      //viewFeaturesProgettoTesi: false,
    };
  },

  beforeCreate() {
    if (!config.isGeodidalab) {
      router.replace({
        name: "index",
      });
    }
  },

  mounted() {
    this.$store.commit("removeOtherObjects");

    this.omekaIDs = config.omekaIDs;

    this.omekaIDsLoaded = true;

    this.windowWidth = $(window).width();

    $(window).resize(() => {
      this.windowWidth = $(window).width();
    });

    this.getCostMatricesOmeka();

    this.checkFilter();

    if (
      this.$store.state.aree.length > 0 &&
      store.getters.selectedAreaCreateItinerary === null
    ) {
      var areaTitle = this.$store.state.aree[0]["o:title"];
      store.commit("setSelectedArea", { areaTitle });
    }

    this.$store.state.remainingTimeAvailable =
      this.$store.state.timeAvailable.milliseconds;

    if (this.$store.getters.viewFeaturesProgettoTesi) {
      //Per capire se considerare un'ora in meno devo vedere se la fascia oraria del pranzo è compresa o no

      var customTimeSlot = this.$store.getters.getCustomTimeSlot;
      var customTimeSlotStart = customTimeSlot.split("-")[0];
      var customTimeSlotStartHour = parseInt(customTimeSlotStart.split(":")[0]);
      var customTimeSlotStartMinute = parseInt(
        customTimeSlotStart.split(":")[1]
      );

      var customTimeSlotEnd = customTimeSlot.split("-")[1];
      var customTimeSlotEndHour = parseInt(customTimeSlotEnd.split(":")[0]);
      var customTimeSlotEndMinute = parseInt(customTimeSlotEnd.split(":")[1]);

      //TODO: RICONTROLLARE BENE QUESTO IF
      if (customTimeSlotStartHour <= 13 && customTimeSlotEndHour >= 13) {
        this.$store.state.remainingTimeAvailable -= 3600000;
      }
    }

    this.$store.state.remainingTimeAvailable -= this.bestPath;

    this.$store.state.areasWithSomethingSelected = [];

    if (store.state.POIpivot !== []) {
      this.filteredPOI = store.state.POIpivot;
      self.activitiesLoaded = true;
      self.isLoadingEsperimenti = false;
    }

    //SINCRONIZZO I FILTERED POI CON LA LISTA DELLE ATTIVITA SELEZIONATE
    Array.prototype.forEach.call(
      store.getters.activitiesSelectedList,
      (actListItem) => {
        Array.prototype.forEach.call(this.filteredPOI, (poi) => {
          if (
            actListItem["o:title"] ===
            "Visita " + poi["geo:Titolo_it"][0]["@value"]
          ) {
            this.$set(poi, "visitPOI", true);
          }

          if (poi.mis) {
            Array.prototype.forEach.call(poi.mis, (activity) => {
              if (actListItem["o:title"] === activity["o:title"]) {
                this.$set(activity, "selected", true);
                this.$set(poi, "poiHasActivitiesSelected", true);
              }
            });
          }
        });
      }
    );

    Array.prototype.forEach.call(this.filteredPOI, (poi) => {
      var numberOfActivitiesSelectedInPOI = 0;

      if (poi.visitPOI) {
        this.$store.state.remainingTimeAvailable -=
          parseInt(poi["geo:Durata"][0]["@value"]) * 60000;

        this.$store.state.areasWithSomethingSelected.push(
          poi["geo:appartiene_a_area"][0]["value_resource_id"] //id dell'area in cui si trova il POI
        );
      }

      Array.prototype.forEach.call(poi.mis, (activity) => {
        if (activity.selected) {
          var activityOrganizationTime = activity["geo:Durata_organizzazione"]
            ? parseInt(activity["geo:Durata_organizzazione"][0]["@value"])
            : config.omekaIDs.defaultOrganizationTime;
          var activityOrganizationTimeMilliseconds =
            activityOrganizationTime * 60000;

          this.$store.state.remainingTimeAvailable -=
            parseInt(activity["geo:Durata"][0]["@value"]) * 60000 +
            activityOrganizationTimeMilliseconds;

          this.$store.state.areasWithSomethingSelected.push(
            poi["geo:appartiene_a_area"][0]["value_resource_id"] //id dell'area in cui si trova il POI
          );

          numberOfActivitiesSelectedInPOI += 1;
        }
      });

      poi.numberOfActivitiesSelectedInPOI = numberOfActivitiesSelectedInPOI;
    });

    // Sincronizzo i filtri
    this.setPOIVisibilityWithInterestsSelected();

    //Sincronizzo la tipologia di attività
    // this.filterActivitiesOfCorrectActivityType();

    //Sincronizzo il livello di difficoltà
    //this.filterPOIofCorrectDifficulty();

    this.initializeMarkersOfFilteredPOI();

    if (this.selectedInterests.length > 0) {
      this.poiLoaded = true;
    }
  },

  async beforeMount() {
    var self = this;

    if (this.$store.state.timeAvailable === null) {
      this.$store.state.timeAvailable = {};
      this.$store.state.timeAvailable.hour = 6;
      this.$store.state.timeAvailable.milliseconds = 21600000;
      this.$store.state.timeAvailable.minutes = 0;
    }

    var self = this;

    //Query che vengono fatte anche in percorsi, ma se l'utente carica questa pagina vanno fatte qua per la prima volta
    /**
     * 121 : class id POI_Pivot
     */
    Common.getElemsByClass(this, config.omekaIDs.omekaIDpoiPIVOT, (res) => {
      store.state.POIpivot = res.body;
      self.isLoadingPOIPivot = false;

      Array.prototype.forEach.call(store.state.POIpivot, (poi) => {
        if (poi.hasOwnProperty("o-module-mapping:marker")) {
          // Get module-mapping
          Common.getElemByUrl(
            self,
            poi["o-module-mapping:marker"][0]["@id"],
            (r2) => {
              poi.marker = r2.body;
            }
          );
        } else {
          /*Il POI non ha nessuna coordinata*/
        }

        poi.visitPOI = false;
        poi.numberOfActivitiesSelectedInPOI = 0;

        /*chiedo l'immagine dei POI*/
        Common.getElementImages(this, poi, (mediaList) => {
          poi.media = mediaList;
          //self.isLoadingImages = false;
        });
      });

      /**
       * 132 : class id geo:Area
       */
      Common.getElemsByClass(this, config.omekaIDs.omekaIDarea, (res) => {
        store.state.aree = res.body;

        var indexGeodidalab = -1;

        Array.prototype.forEach.call(store.state.aree, (area) => {
          if (area["o:title"].toLowerCase().includes("geodidalab")) {
            indexGeodidalab = store.state.aree.indexOf(area);
          }
        });

        var firstElement = store.state.aree[0];
        store.state.aree[0] = store.state.aree[indexGeodidalab];
        store.state.aree[indexGeodidalab] = firstElement;

        self.isLoadingAree = false;
      });

      /**
       * 118 : class id Misurazione
       * 130 : class id Attivita
       */

      //chiedo gli esperimenti perchè magari non sono mai andato nella pagina dedicata a loro prima d'ora, ma mi servono qua
      Common.getElemsByClass(this, config.omekaIDs.omekaIDattivita, (res) => {
        store.state.esperimenti = res.body;
        store.commit("setActivitiesInPOI");
        this.filteredPOI = store.state.POIpivot;
        this.initializeMarkersOfFilteredPOI();

        self.activitiesLoaded = true;
        self.isLoadingEsperimenti = false;
      });

      //chiedo i livelli di difficoltà
      Common.getElemsByClass(
        this,
        config.omekaIDs.omekaIDlivelliDifficolta,
        (res) => {
          store.state.difficultyLevels = res.body;

          var indexPerTutti = -1;

          Array.prototype.forEach.call(
            store.state.difficultyLevels,
            (level) => {
              if (level["o:title"] === "Per Tutti") {
                indexPerTutti = store.state.difficultyLevels.indexOf(level);
              }
            }
          );

          var firstElement = store.state.difficultyLevels[0];
          store.state.difficultyLevels[0] =
            store.state.difficultyLevels[indexPerTutti];
          store.state.difficultyLevels[indexPerTutti] = firstElement;

          store.commit("setAllExpertiseLevels");
          self.difficultyLevelsLoaded = true;
        }
      );

      //chiedo gli interessi
      Common.getElemsByClass(this, config.omekaIDs.omekaIDinteressi, (res) => {
        store.state.interestsObject = res.body;
        store.commit("setAllinterestOfPOI");

        self.interestsLoaded = true;
      });

      //chiedo le tipologie di attività
      Common.getElemsByClass(
        this,
        config.omekaIDs.omekaIDtipologiaAttivita,
        (res) => {
          store.state.activityTypeOmeka = res.body;
          store.commit("setAllactivityType");

          self.activityTypeLoaded = true;
        }
      );
    });

    var self = this;

    if (this.$store.state.viewFeaturesProgettoTesi) {
      //var body = "[out:json];node(48.865,2.25,48.9,2.27)[amenity=restaurant];out;"
      //Richiesta ristoranti nella zona
      (async () => {
        const api = await fetch(
          "https://www.overpass-api.de/api/interpreter?",
          {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: "[out:json];node(45.45,7.86,45.48,7.89)[amenity=restaurant];out;",
          }
        );
        const answer = await api.json();

        Array.prototype.forEach.call(answer.elements, (restaurant) => {
          self.restaurantsMarkers.push({
            marker: L.marker([restaurant.lat, restaurant.lon]),
            color: "#1585bd",
            strokeColor: "#1b4f88",
            circleColor: "#ffffff",
            POItitle: restaurant.tags.name,
            poiSelected: false,
            description: null,
            city: restaurant.tags["addr:city"],
            country: restaurant.tags["addr:country"],
            housenumber: restaurant.tags["addr:housenumber"],
            postcode: restaurant.tags["addr:postcode"],
            street: restaurant.tags["addr:street"],
            name: restaurant.tags["name"],
            phone: restaurant.tags["phone"],
            wheelchair: restaurant.tags["wheelchair"],
            image: undefined,
          });
        });
      })();

      // Richiesta bar nella zona
      (async () => {
        const api = await fetch(
          "https://www.overpass-api.de/api/interpreter?",
          {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: "[out:json];node(45.45,7.86,45.48,7.89)[amenity=bar];out;",
          }
        );
        const answer = await api.json();

        Array.prototype.forEach.call(answer.elements, (bar) => {
          self.barsMarkers.push({
            marker: L.marker([bar.lat, bar.lon]),
            color: "#1585bd",
            strokeColor: "#1b4f88",
            circleColor: "#ffffff",
            POItitle: bar.tags.name,
            poiSelected: false,
            description: null,
            city: bar.tags["addr:city"],
            country: bar.tags["addr:country"],
            housenumber: bar.tags["addr:housenumber"],
            postcode: bar.tags["addr:postcode"],
            street: bar.tags["addr:street"],
            name: bar.tags["name"],
            phone: bar.tags["phone"],
            wheelchair: bar.tags["wheelchair"],
            image: undefined,
          });
        });
      })();
    }
  },

  methods: {
    getLink(link){
      if(link.split('~').length > 1) {
        var split = link.split('~');
        return split[1];
      } else {
        return link;
      }
    },
    getLinkName(link){
      if(link.split('~').length > 1) {
        var split = link.split('~');
        return split[0];
      } else {
        return "Dettagli";
      }
    },
    getCostMatricesOmeka() {
      Common.getElemsByClass(
        this,
        config.omekaIDs.omekaIDmatriciSpostamenti,
        (res) => {
          store.state.omekaCsvMatrixes = res.body;
          store.commit("initCostMatrixPOI");
          store.commit("initCostMatrixAreas");
        }
      );
    },

    getInterestsCollapseTitle() {
      var interests = this.$store.state.interests.filter(
        (interest) => interest.interestSelected
      );

      var title = "Interessi luoghi ";

      if (interests.length === 0) {
        // non concateno nulla
      } else if (interests.length === 1) {
        title += "(" + interests.length + " selezionato)";
      } else {
        title += "(" + interests.length + " selezionati)";
      }

      return title;
    },

    getActivityTypeCollapseTitle() {
      var actType = this.$store.state.activityType.filter(
        (activityType) => activityType.activityTypeSelected
      );

      var title = "Tipologia attività ";

      if (actType.length === 0) {
        // non concateno nulla
      } else if (actType.length === 1) {
        title += "(" + actType.length + " selezionata)";
      } else {
        title += "(" + actType.length + " selezionate)";
      }

      return title;
    },

    getAddActivitiesCollapseTitle(poi) {
      var title = "Aggiungi attività";
      var count = 0;
      Array.prototype.forEach.call(poi.mis, (activity) => {
        if (
          activity.activityVisibleWithDifficultiesFilters &&
          activity.activityVisibleWithInterestsFilters &&
          activity.activityVisibleWithActivityTypeFilters
        ) {
          count++;
        }
      });

      if (count === 0) {
        return title;
      } else {
        title += " (" + count + " visibili con i filtri)";
        return title;
      }
    },

    find_index(PoiID) {
      var index = 0;
      var found = false;

      var matrix = this.$store.state.costMatricesTimeBetweenPOI.sort(
        (a, b) => parseInt(a.PoiID) - parseInt(b.PoiID)
      );

      for (var i = 0; i < matrix.length && !found; i++) {
        if (matrix[i].PoiID == PoiID) {
          index = i;
          found = true;
        }
      }

      return index;
    },

    removeAllActivities() {
      var activitiesCopy = JSON.parse(
        JSON.stringify(this.$store.getters.activitiesSelectedList)
      );

      Array.prototype.forEach.call(activitiesCopy, (activity) => {
        if (activity.isVisit) {
          var tmpFilteredPOI = this.filteredPOI;
          var tmpPoi = tmpFilteredPOI.filter(
            (poi) =>
              poi["geo:Titolo_it"][0]["@value"] ===
              activity["geo:Titolo_it"][0]["@value"]
          );

          if (tmpPoi[0].visitPOI) {
            this.changeSelectionVisitPOI(
              activity["geo:Titolo_it"][0]["@value"]
            );
          } else {
            //La visita è già stata rimossa quando si è rimossa l'ultima attività del luogo
          }
        } else {
          this.changeSelection(
            activity["geo:Titolo_it"][0]["@value"],
            activity["o:title"]
          );
        }
      });
    },

    checkFilter() {
      this.interestsLoaded = this.$store.state.interests.length > 0;
      this.difficultyLevelsLoaded =
        this.$store.state.expertiseLevels.length > 0;
      this.activityTypeLoaded = this.$store.state.activityType.length > 0;
    },

    getInterestList(list, poi) {
      //Interessi delle attività del POI
      var newList = [];
      Array.prototype.forEach.call(poi.mis, (activity) => {
        Array.prototype.forEach.call(
          activity["geo:ha_interesse"],
          (interest) => {
            newList.push(interest["display_title"]);
          }
        );
      });

      for (var i = 0; i < list.length; i++) {
        newList.push(list[i]["display_title"]);
      }

      return [...new Set(newList)];
    },

    getInterestListActivity(list) {
      var newList = [];

      for (var i = 0; i < list.length; i++) {
        newList.push(list[i]["display_title"]);
      }

      return newList;
    },

    getGroupName(item) {
      return item["geo:Titolo_it"][0]["@value"].replaceAll('"', "");
    },

    checkDuration(it) {
      var organizationTime = it["geo:Durata_organizzazione"];

      if (organizationTime === undefined) {
        organizationTime = this.omekaIDs.defaultOrganizationTime * 60000;
      } else {
        organizationTime = organizationTime[0]["@value"] * 60000;
      }
      return (
        parseInt(it["geo:Durata"][0]["@value"]) * 60000 + organizationTime <=
        this.$store.state.remainingTimeAvailable
      );
    },

    incrementStep() {
      this.totalItinerary = [];

      if (
        this.$store.state.remainingTimeAvailable ===
        this.$store.state.timeAvailable.milliseconds
      ) {
        this.modals.featureDevelopment = true;
      } else {
        this.modals.loadingVROOMresponse = true;

        Array.prototype.forEach.call(this.$store.state.aree, (area) => {
          var POIofArea = this.filteredPOI.filter(
            (poi) =>
              poi["geo:appartiene_a_area"][0]["display_title"] ===
              area["o:title"]
          );

          if (POIofArea.length > 0) {
            var matrixWithRowForStardAndEndPoint =
              store.state.vroomCostMatricesTimeBetweenPOI.map(function (arr) {
                return arr.slice();
              });

            var arrayOfZeros = new Array(
              matrixWithRowForStardAndEndPoint[0].length
            ).fill(0);

            matrixWithRowForStardAndEndPoint.push(arrayOfZeros);

            Array.prototype.forEach.call(
              matrixWithRowForStardAndEndPoint,
              (row) => {
                row.push(0);
              }
            );

            var indexOfStardAndEndPoint =
              matrixWithRowForStardAndEndPoint.length - 1;

            var vroomObject = {
              jobs: [],
              vehicles: [
                {
                  id: 1,
                  profile: "car",
                  start_index: indexOfStardAndEndPoint,
                  end_index: indexOfStardAndEndPoint,
                  start: [
                    POIofArea[0].marker["o-module-mapping:lat"],
                    POIofArea[0].marker["o-module-mapping:lng"],
                  ],
                  end: [
                    POIofArea[0].marker["o-module-mapping:lat"],
                    POIofArea[0].marker["o-module-mapping:lng"],
                  ],
                  time_window: [
                    0,
                    this.$store.state.timeAvailable.milliseconds,
                  ],
                },
              ],
              matrices: {
                car: {
                  durations: matrixWithRowForStardAndEndPoint, //store.state.vroomCostMatricesTimeBetweenPOI,
                  costs: matrixWithRowForStardAndEndPoint, //store.state.vroomCostMatricesTimeBetweenPOI,
                },
              },
            };

            //oggetto contenente i POI con delle attività selezionate
            var poiWithSelectedActivities = POIofArea.filter(
              (poi) => poi.poiHasActivitiesSelected || poi.visitPOI
            );

            var jobID = 1;
            var currentPlaceID = 0;

            Array.prototype.forEach.call(POIofArea, (poi) => {
              if (poi.visitPOI) {
                var index =
                  this.$store.state.costMatricesTimeBetweenPOI.findIndex(
                    (object) => {
                      return parseInt(object.PoiID) === poi["o:id"];
                    }
                  );

                if (index === -1) {
                  //USO LA RIGA PER I PUNTI CHE NON SONO PRESENTI IN MATRICE
                  index =
                    this.$store.state.costMatricesTimeBetweenPOI.length - 1;
                }

                //se l'utente vuole visitare il POI viene aggiunto il Job
                var visitPOIjob = {
                  id: jobID, //1, //l'id deve essere stabilito a priori, ad esempio: lago licheni -> 1
                  description:
                    poi["geo:Titolo_it"][0]["@value"] +
                    "_Visita del luogo_" +
                    poi["o:id"],
                  service: this.getMilliseconds(poi["geo:Durata"][0]["@value"]),
                  location_index: index,
                };

                if (poi.marker) {
                  visitPOIjob.location = [
                    poi.marker["o-module-mapping:lng"],
                    poi.marker["o-module-mapping:lat"],
                  ];
                }

                vroomObject.jobs.push(visitPOIjob);

                jobID += 1;
              }
            });

            //creo i jobs per l'oggetto VROOM
            Array.prototype.forEach.call(poiWithSelectedActivities, (poi) => {
              var activitiesSelected = poi.mis.filter(
                (activity) => activity.selected
              );

              var indexTest = this.find_index(poi["o:id"]);
              if (indexTest === -1) {
                //USO LA RIGA PER I PUNTI CHE NON SONO PRESENTI IN MATRICE
                indexTest =
                  this.$store.state.costMatricesTimeBetweenPOI.length - 1;
              }
              currentPlaceID = indexTest;

              Array.prototype.forEach.call(activitiesSelected, (activity) => {
                var desc =
                  poi["geo:Titolo_it"][0]["@value"] +
                  "_" +
                  activity["o:title"] +
                  "_";

                if (activity["geo:ha_tipologia_attivita"] !== undefined) {
                  desc +=
                    activity["geo:ha_tipologia_attivita"][0]["display_title"];
                } else {
                  desc += "Non disponibile";
                }

                desc += "_" + poi["o:id"];

                var setupTime = activity["geo:Durata_organizzazione"]
                  ? activity["geo:Durata_organizzazione"][0]["@value"]
                  : config.omekaIDs.defaultOrganizationTime.toString();

                var job = {
                  id: jobID, //1, //l'id deve essere stabilito a priori, ad esempio: lago licheni -> 1
                  description: desc,
                  service: this.getMilliseconds(
                    activity["geo:Durata"][0]["@value"]
                  ),
                  location: [
                    poi.marker["o-module-mapping:lng"],
                    poi.marker["o-module-mapping:lat"],
                  ],
                  location_index: currentPlaceID,
                  setup: this.getMilliseconds(setupTime),
                };

                vroomObject.jobs.push(job);

                jobID += 1;
              });
            });

            if (vroomObject.jobs.length !== 0) {
              var vroomItineraryResponse = this.makeQueryVROOM(
                vroomObject,
                area["o:title"],
                area["o:id"]
              );
            } // else -> area senza attività selezionate
          }
        });
      }
    },
    initializeMarkersOfFilteredPOI() {
      this.markers = [];

      Array.prototype.forEach.call(this.filteredPOI, (poi) => {
        if (poi.poiVisibleWithFilters || poi.poiHasActivitiesSelected) {
          if (poi["marker"]) {
            this.markers.push({
              marker: L.marker([
                poi.marker["o-module-mapping:lat"],
                poi.marker["o-module-mapping:lng"],
              ]),
              color: "#1585bd",
              strokeColor: "#1b4f88",
              circleColor: "#ffffff",
              POItitle: poi["geo:Titolo_it"][0]["@value"],
              poiSelected: poi.poiHasActivitiesSelected || poi.visitPOI,
              description: poi["dcterms:description"]
                ? poi["dcterms:description"][0]["@value"]
                : "Nessuna descrizione disponibile",
              image:
                poi["media"] && poi["media"][0]
                  ? poi["media"][0]["o:thumbnail_urls"]["large"]
                  : undefined,
            });
          }
        }
      });

      this.markersCreated = true;
    },

    visitPlaceClicked(poiName) {
      var self = this;
      var tmpFilteredPOI = this.filteredPOI;

      Array.prototype.forEach.call(tmpFilteredPOI, (poi) => {
        if (poi["geo:Titolo_it"][0]["@value"] === poiName) {
          this.$set(poi, "visitPOI", !poi.visitPOI);

          if (poi.visitPOI) {
            // prima la visita del POI non era selezionata ed ora lo è

            //qua bisogna controllare se l'area di appartenenza del POI è già nell'elenco delle aree selezionate o no
            if (
              this.$store.state.areasWithSomethingSelected.filter(
                (area) =>
                  area === poi["geo:appartiene_a_area"][0]["value_resource_id"]
              ).length > 0
            ) {
              //qua posso tranquillamente controllare se la visita sta nel tempo che rimane a disposizione
              if (
                parseInt(poi["geo:Durata"][0]["@value"]) * 60000 <=
                this.$store.state.remainingTimeAvailable
              ) {
                //la durata dell'attività è minore o uguale rispetto al tempo rimanente, quindi può essere inserita!
                this.$store.state.remainingTimeAvailable -=
                  parseInt(poi["geo:Durata"][0]["@value"]) * 60000;

                //bisogna aggiungere ancora una volta l'area di appartenenza del poi
                this.$store.state.areasWithSomethingSelected.push(
                  poi["geo:appartiene_a_area"][0]["value_resource_id"] //id dell'area in cui si trova il POI
                );

                this.addActivityVisitPOIToList(poi);
              } else {
                this.errorMessage =
                  "La visita non sta nel tempo rimanente a disposizione.";
                this.modals.timeExceeded = true;

                this.$set(poi, "visitPOI", !poi.visitPOI);
              }
            } else {
              //aggiungiamo in modo fittizio l'area del POI
              this.$store.state.areasWithSomethingSelected.push(
                poi["geo:appartiene_a_area"][0]["value_resource_id"]
              );
              var timeBetweenAreas = this.bestPath;

              var timeToAdd = parseInt(poi["geo:Durata"][0]["@value"]) * 60000;
              //non devo aggiungere lo spostamento tra le aree perchè viene fatto in automatico dal computed bestPath // + timeBetweenAreas;

              if (
                timeToAdd + timeBetweenAreas <=
                this.$store.state.remainingTimeAvailable
              ) {
                //la durata dell'attività è minore o uguale rispetto al tempo rimanente, quindi può essere inserita!
                this.$store.state.remainingTimeAvailable -= timeToAdd;
                this.addActivityVisitPOIToList(poi);
              } else {
                this.errorMessage =
                  "Per poter visitare questo luogo è necessario spostarsi anche tra un'area all'altra e la visita e lo spostamento non stanno nel tempo rimanente a disposizione.";
                this.modals.timeExceeded = true;

                //rimuovo l'area tra le aree con qualcosa di selezionato visto che non ci si può andare con nel tempo rimanente
                var index =
                  this.$store.state.areasWithSomethingSelected.indexOf(
                    poi["geo:appartiene_a_area"][0]["value_resource_id"]
                  );
                if (index > -1) {
                  this.$store.state.areasWithSomethingSelected.splice(index, 1);
                }

                this.$set(poi, "visitPOI", !poi.visitPOI);
              }
            }
          } else {
            this.$store.state.remainingTimeAvailable +=
              parseInt(poi["geo:Durata"][0]["@value"]) * 60000; //aggiungo il tempo a disposizione avendo rimosso la visita

            //rimuovo l'attività dalla lista delle attività
            var indexOfActivity = 0;

            for (
              var i = 0;
              i < store.getters.activitiesSelectedList.length;
              i++
            ) {
              if (
                store.getters.activitiesSelectedList[i]["o:title"] ===
                "Visita " + poiName
              ) {
                indexOfActivity = i;
              }
            }

            //store.state.activitiesSelectedList.splice(indexOfActivity, 1);
            store.commit("removeActivityFromSelectedList", { indexOfActivity });

            //ho rimosso l'attività dalla lista delle attività

            var index = this.$store.state.areasWithSomethingSelected.indexOf(
              poi["geo:appartiene_a_area"][0]["value_resource_id"]
            );
            if (index > -1) {
              this.$store.state.areasWithSomethingSelected.splice(index, 1);
            }
          }
        }
      });

      for (var i = 0; i < this.filteredPOI.length; i++) {
        this.$set(this.filteredPOI, i, tmpFilteredPOI[i]);
      }

      this.initializeMarkersOfFilteredPOI();
    },

    initVisitOrActivityMutex() {
      this.activityMutex = null;
      this.visitPOIMutex = null;
      this.modals.addActivityOrVisit = false;
    },

    addVisitPOIMutex() {
      var poi = this.visitPOIMutex;

      this.$store.state.remainingTimeAvailable -=
        parseInt(poi["geo:Durata"][0]["@value"]) * 60000; //rimuovo la durata della visita del POI

      this.addActivityVisitPOIToList(poi);

      Array.prototype.forEach.call(this.filteredPOI, (p) => {
        if (
          p["geo:Titolo_it"][0]["@value"] === poi["geo:Titolo_it"][0]["@value"]
        ) {
          this.$set(p, "visitPOI", true);
        }
      });

      //aggiungo anche la'area del POI
      this.$store.state.areasWithSomethingSelected.push(
        poi["geo:appartiene_a_area"][0]["value_resource_id"]
      );

      this.modals.addActivityOrVisit = false;
    },

    addActivityMutex() {
      var activity = this.activityMutex;

      var activityOrganizationTime = activity["geo:Durata_organizzazione"]
        ? parseInt(activity["geo:Durata_organizzazione"][0]["@value"])
        : config.omekaIDs.defaultOrganizationTime;
      var activityOrganizationTimeMilliseconds =
        activityOrganizationTime * 60000;

      this.$store.state.remainingTimeAvailable -=
        parseInt(activity["geo:Durata"][0]["@value"]) * 60000 +
        activityOrganizationTimeMilliseconds; //rimuovo la durata della visita del POI

      Array.prototype.forEach.call(this.filteredPOI, (p) => {
        Array.prototype.forEach.call(p.mis, (a) => {
          if (a["o:title"] === activity["o:title"]) {
            a.selected = true; //imposto l'attività come selezionata
            p.poiHasActivitiesSelected = true; //devo impostare che il poi ha un'attivitò selezionata
            p.numberOfActivitiesSelectedInPOI += 1;
            this.addActivityToList(activity, p);

            this.$bus.$emit("changeSelectionActivity", activity);

            //aggiungo anche la'area del POI
            this.$store.state.areasWithSomethingSelected.push(
              p["geo:appartiene_a_area"][0]["value_resource_id"]
            );
          }
        });
      });

      this.modals.addActivityOrVisit = false;
    },

    addActivityToList(activity, poi) {
      //l'attività è stata appena selezionata
      var activityTmp = JSON.parse(JSON.stringify(activity));
      activityTmp["geo:Durata"] = activity["geo:Durata"];
      activityTmp["geo:appartiene_a_area"] = poi["geo:appartiene_a_area"];
      activityTmp["geo:Titolo_it"] = poi["geo:Titolo_it"];
      activityTmp["o:title"] = activity["o:title"];
      activityTmp["poi"] = poi;
      activityTmp.isVisit = false;

      store.commit("addActivityToSelectedList", { activityTmp });
    },

    addActivityVisitPOIToList(poi) {
      //l'attività è stata appena selezionata
      var activityTmp = {};
      activityTmp["geo:Durata"] = poi["geo:Durata"];
      activityTmp["geo:appartiene_a_area"] = poi["geo:appartiene_a_area"];
      activityTmp["geo:Titolo_it"] = poi["geo:Titolo_it"];
      activityTmp["o:title"] = "Visita " + poi["geo:Titolo_it"][0]["@value"];
      activityTmp["poi"] = poi;

      activityTmp.isVisit = true;

      store.commit("addActivityToSelectedList", { activityTmp });

      this.lastActivityOrVisitSelected.type = "Visit";
      this.lastActivityOrVisitSelected.name = poi["geo:Titolo_it"][0]["@value"];
    },

    changeSelectionVisitPOI(poiName) {
      var tmpFilteredPOI = this.filteredPOI;

      Array.prototype.forEach.call(tmpFilteredPOI, (poi) => {
        if (poi["geo:Titolo_it"][0]["@value"] === poiName) {
          var visit = poi.visitPOI;
          this.$set(poi, "visitPOI", !visit);

          if (poi.visitPOI) {
          } else {
            this.$store.state.remainingTimeAvailable +=
              parseInt(poi["geo:Durata"][0]["@value"]) * 60000; //rimuovo la durata della visita del POI

            //rimuovo l'attività dalla lista delle attività
            var indexOfActivity = 0;

            for (
              var i = 0;
              i < store.getters.activitiesSelectedList.length;
              i++
            ) {
              if (
                store.getters.activitiesSelectedList[i]["o:title"] ===
                "Visita " + poiName
              ) {
                indexOfActivity = i;
              }
            }

            //store.state.activitiesSelectedList.splice(indexOfActivity, 1);
            store.commit("removeActivityFromSelectedList", { indexOfActivity });
            //ho rimosso l'attivitàà dalla lista delle attività

            var index = this.$store.state.areasWithSomethingSelected.indexOf(
              poi["geo:appartiene_a_area"][0]["value_resource_id"]
            );

            if (index > -1) {
              this.$store.state.areasWithSomethingSelected.splice(index, 1);
            }
          }
        }
      });

      //imposto se il POI ha delle attività selezionate
      Array.prototype.forEach.call(tmpFilteredPOI, (poi) => {
        var poiHasActivitiesSelected = false;

        Array.prototype.forEach.call(poi.mis, (activity) => {
          if (activity.selected) {
            poiHasActivitiesSelected = true;
          }
        });

        // il poi ha delle attività selezionate se è selezionata la sua visita oppure delle attività da fare al suo interno
        poi.poiHasActivitiesSelected = poiHasActivitiesSelected || poi.visitPOI;
      });

      for (var i = 0; i < this.filteredPOI.length; i++) {
        this.$set(this.filteredPOI, i, tmpFilteredPOI[i]);
      }

      this.initializeMarkersOfFilteredPOI();
    },

    changeSelection(poiName, activityName) {
      var tmpFilteredPOI = this.filteredPOI;

      Array.prototype.forEach.call(tmpFilteredPOI, (poi) => {
        if (poi["geo:Titolo_it"][0]["@value"] === poiName) {
          Array.prototype.forEach.call(poi.mis, (activity) => {
            if (activity["o:title"] === activityName) {
              if (!activity.selected) {
                // l'attività non è selezionata e la voglio selezionare

                if (
                  this.$store.state.areasWithSomethingSelected.filter(
                    (area) =>
                      area ===
                      poi["geo:appartiene_a_area"][0]["value_resource_id"]
                  ).length > 0
                ) {
                  if (
                    poi.numberOfActivitiesSelectedInPOI === 0 &&
                    !poi.visitPOI
                  ) {
                    var activityOrganizationTime = activity[
                      "geo:Durata_organizzazione"
                    ]
                      ? parseInt(
                          activity["geo:Durata_organizzazione"][0]["@value"]
                        )
                      : config.omekaIDs.defaultOrganizationTime;
                    var activityOrganizationTimeMilliseconds =
                      activityOrganizationTime * 60000;

                    var timeCheck =
                      parseInt(poi["geo:Durata"][0]["@value"]) * 60000 +
                      parseInt(activity["geo:Durata"][0]["@value"]) * 60000 +
                      activityOrganizationTimeMilliseconds;

                    if (timeCheck <= this.$store.state.remainingTimeAvailable) {
                      this.$set(poi, "visitPOI", true);
                      activity.selected = !activity.selected;

                      this.$bus.$emit("changeSelectionActivity", activity);

                      this.addActivityToList(activity, poi);
                      this.addActivityVisitPOIToList(poi);

                      poi.numberOfActivitiesSelectedInPOI += 1;

                      //l'area va aggiunta una volta per il POI e una per la visita!
                      this.$store.state.areasWithSomethingSelected.push(
                        poi["geo:appartiene_a_area"][0]["value_resource_id"]
                      );
                      this.$store.state.areasWithSomethingSelected.push(
                        poi["geo:appartiene_a_area"][0]["value_resource_id"]
                      );

                      this.$store.state.remainingTimeAvailable -= timeCheck;
                    } else {
                      var timeCheck =
                        parseInt(poi["geo:Durata"][0]["@value"]) * 60000;

                      if (
                        timeCheck <= this.$store.state.remainingTimeAvailable
                      ) {
                        this.visitPOIMutex = poi;
                      }

                      var activityOrganizationTime = activity[
                        "geo:Durata_organizzazione"
                      ]
                        ? parseInt(
                            activity["geo:Durata_organizzazione"][0]["@value"]
                          )
                        : config.omekaIDs.defaultOrganizationTime;
                      var activityOrganizationTimeMilliseconds =
                        activityOrganizationTime * 60000;

                      var timeCheck =
                        parseInt(activity["geo:Durata"][0]["@value"]) * 60000 +
                        activityOrganizationTimeMilliseconds;

                      if (
                        timeCheck <= this.$store.state.remainingTimeAvailable
                      ) {
                        this.activityMutex = activity;
                      }

                      if (
                        this.activityMutex !== null ||
                        this.visitPOIMutex !== null
                      ) {
                        this.modals.addActivityOrVisit = true;
                      } else {
                        //dato che c'è anche lo spostamento nulla può essere aggiunto, nè la visita nè l'attività
                        if (this.activityMutex === null) {
                          this.errorMessage =
                            "Non è possibile selezionare l'attività.";
                        }

                        if (this.visitPOIMutex === null) {
                          this.errorMessage =
                            "Non è possibile selezionare la visita.";
                        }

                        this.modals.timeExceeded = true;
                      }

                      //alert("NON POSSO AGGIUNGERE ATTIVITA E VISITA INSIEME");
                    }
                  } else {
                    var activityOrganizationTime = activity[
                      "geo:Durata_organizzazione"
                    ]
                      ? parseInt(
                          activity["geo:Durata_organizzazione"][0]["@value"]
                        )
                      : config.omekaIDs.defaultOrganizationTime;
                    var activityOrganizationTimeMilliseconds =
                      activityOrganizationTime * 60000;

                    var timeCheck =
                      parseInt(activity["geo:Durata"][0]["@value"]) * 60000 +
                      activityOrganizationTimeMilliseconds;

                    if (timeCheck <= this.$store.state.remainingTimeAvailable) {
                      activity.selected = !activity.selected;

                      this.$bus.$emit("changeSelectionActivity", activity);

                      this.addActivityToList(activity, poi);
                      poi.numberOfActivitiesSelectedInPOI += 1;
                      this.$store.state.areasWithSomethingSelected.push(
                        poi["geo:appartiene_a_area"][0]["value_resource_id"]
                      );

                      this.$store.state.remainingTimeAvailable -= timeCheck;
                    } else {
                      this.errorMessage =
                        "L'attività non sta nel tempo rimanente a disposizione.";
                      this.modals.timeExceeded = true;
                    }
                  }
                } else {
                  //l'area non c'è già
                  var oldPestPath = this.bestPath;
                  var timeBetweenAreas = this.bestPath;

                  if (
                    poi.numberOfActivitiesSelectedInPOI === 0 &&
                    !poi.visitPOI
                  ) {
                    var activityOrganizationTime = activity[
                      "geo:Durata_organizzazione"
                    ]
                      ? parseInt(
                          activity["geo:Durata_organizzazione"][0]["@value"]
                        )
                      : config.omekaIDs.defaultOrganizationTime;
                    var activityOrganizationTimeMilliseconds =
                      activityOrganizationTime * 60000;

                    var timeCheck =
                      parseInt(poi["geo:Durata"][0]["@value"]) * 60000 +
                      parseInt(activity["geo:Durata"][0]["@value"]) * 60000 +
                      activityOrganizationTimeMilliseconds;

                    var value = timeCheck + timeBetweenAreas - oldPestPath; // rimuovo il vecchio tempo di spostamnto e metto il nuovo

                    if (timeCheck <= this.$store.state.remainingTimeAvailable) {
                      this.$set(poi, "visitPOI", true);
                      activity.selected = !activity.selected;

                      this.$bus.$emit("changeSelectionActivity", activity);

                      this.addActivityToList(activity, poi);
                      this.addActivityVisitPOIToList(poi);

                      poi.numberOfActivitiesSelectedInPOI += 1;

                      //l'area va aggiunta una volta per il POI e una per la visita!
                      this.$store.state.areasWithSomethingSelected.push(
                        poi["geo:appartiene_a_area"][0]["value_resource_id"]
                      );
                      this.$store.state.areasWithSomethingSelected.push(
                        poi["geo:appartiene_a_area"][0]["value_resource_id"]
                      );

                      this.$store.state.remainingTimeAvailable -= timeCheck;
                    } else {
                      var timeCheck =
                        parseInt(poi["geo:Durata"][0]["@value"]) * 60000;

                      if (
                        timeCheck + timeBetweenAreas <=
                        this.$store.state.remainingTimeAvailable
                      ) {
                        this.visitPOIMutex = poi;
                      }

                      var activityOrganizationTime = activity[
                        "geo:Durata_organizzazione"
                      ]
                        ? parseInt(
                            activity["geo:Durata_organizzazione"][0]["@value"]
                          )
                        : config.omekaIDs.defaultOrganizationTime;
                      var activityOrganizationTimeMilliseconds =
                        activityOrganizationTime * 60000;

                      var timeCheck =
                        parseInt(activity["geo:Durata"][0]["@value"]) * 60000 +
                        activityOrganizationTimeMilliseconds;

                      if (
                        timeCheck + timeBetweenAreas <=
                        this.$store.state.remainingTimeAvailable
                      ) {
                        this.activityMutex = activity;
                      }

                      if (
                        this.activityMutex !== null ||
                        this.visitPOIMutex !== null
                      ) {
                        this.modals.addActivityOrVisit = true;
                      } else {
                        //dato che c'è anche lo spostamento nulla può essere aggiunto, nè la visita nè l'attività
                        if (this.activityMutex === null) {
                          this.errorMessage =
                            "Dato che sarebbe necessario spostarsi da un'area all'altra non è possibile selezionare l'attività.";
                        }

                        if (this.visitPOIMutex === null) {
                          this.errorMessage =
                            "Dato che sarebbe necessario spostarsi da un'area all'altra non è possibile selezionare la visita.";
                        }

                        this.modals.timeExceeded = true;
                      }

                      //rimuovo l'area tra le aree con qualcosa di selezionato visto che non ci si può andare con nel tempo rimanente
                      var index =
                        this.$store.state.areasWithSomethingSelected.indexOf(
                          poi["geo:appartiene_a_area"][0]["value_resource_id"]
                        );
                      if (index > -1) {
                        this.$store.state.areasWithSomethingSelected.splice(
                          index,
                          1
                        );
                      }
                    }
                  } else {
                    var activityOrganizationTime = activity[
                      "geo:Durata_organizzazione"
                    ]
                      ? parseInt(
                          activity["geo:Durata_organizzazione"][0]["@value"]
                        )
                      : config.omekaIDs.defaultOrganizationTime;
                    var activityOrganizationTimeMilliseconds =
                      activityOrganizationTime * 60000;

                    var timeCheck =
                      parseInt(activity["geo:Durata"][0]["@value"]) * 60000 +
                      activityOrganizationTimeMilliseconds;

                    if (
                      timeCheck + timeBetweenAreas <=
                      this.$store.state.remainingTimeAvailable
                    ) {
                      activity.selected = !activity.selected;

                      this.$bus.$emit("changeSelectionActivity", activity);

                      this.addActivityToList(activity, poi);
                      poi.numberOfActivitiesSelectedInPOI += 1;
                      this.$store.state.areasWithSomethingSelected.push(
                        poi["geo:appartiene_a_area"][0]["value_resource_id"]
                      );

                      this.$store.state.remainingTimeAvailable -= timeCheck;
                    } else {
                      this.errorMessage =
                        "L'attività non sta nel tempo rimanente a disposizione.";
                      this.modals.timeExceeded = true;
                    }
                  }
                }
              } else {
                //voglio deselezionare l'attività

                for (
                  var i = 0;
                  i < store.getters.activitiesSelectedList.length;
                  i++
                ) {
                  if (
                    activityName ===
                    store.getters.activitiesSelectedList[i]["o:title"]
                  ) {
                    indexOfActivity = i;
                  }
                }

                //store.state.activitiesSelectedList.splice(indexOfActivity, 1);
                store.commit("removeActivityFromSelectedList", {
                  indexOfActivity,
                });

                //ho rimosso l'attività dalla lista delle attività

                activity.selected = !activity.selected;

                this.$bus.$emit("changeSelectionActivity", activity);

                poi.numberOfActivitiesSelectedInPOI -= 1;

                var activityOrganizationTime = activity[
                  "geo:Durata_organizzazione"
                ]
                  ? parseInt(activity["geo:Durata_organizzazione"][0]["@value"])
                  : config.omekaIDs.defaultOrganizationTime;
                var activityOrganizationTimeMilliseconds =
                  activityOrganizationTime * 60000;

                this.$store.state.remainingTimeAvailable +=
                  parseInt(activity["geo:Durata"][0]["@value"]) * 60000 +
                  activityOrganizationTimeMilliseconds;

                //rimuovo una volta l'area  dalle aree con qualcosa di selezionato
                var index =
                  this.$store.state.areasWithSomethingSelected.indexOf(
                    poi["geo:appartiene_a_area"][0]["value_resource_id"]
                  );
                if (index > -1) {
                  this.$store.state.areasWithSomethingSelected.splice(index, 1);
                }

                if (poi.numberOfActivitiesSelectedInPOI === 0 && poi.visitPOI) {
                  this.$set(poi, "visitPOI", false); //togliamo la visita del POI

                  this.$store.state.remainingTimeAvailable +=
                    parseInt(poi["geo:Durata"][0]["@value"]) * 60000; //togliamo il tempo necessario a visitare il POI

                  //rimuovo l'attività dalla lista delle attività
                  var indexOfActivity = 0;

                  for (
                    var i = 0;
                    i < store.getters.activitiesSelectedList.length;
                    i++
                  ) {
                    if (
                      store.getters.activitiesSelectedList[i][
                        "geo:Titolo_it"
                      ][0]["@value"] === poiName
                    ) {
                      indexOfActivity = i;
                    }
                  }

                  //store.state.activitiesSelectedList.splice(indexOfActivity, 1);
                  store.commit("removeActivityFromSelectedList", {
                    indexOfActivity,
                  });
                  //ho rimosso l'attivitàà dalla lista delle attività

                  //rimuovo una volta l'area  dalle aree con qualcosa di selezionato
                  var index =
                    this.$store.state.areasWithSomethingSelected.indexOf(
                      poi["geo:appartiene_a_area"][0]["value_resource_id"]
                    );
                  if (index > -1) {
                    this.$store.state.areasWithSomethingSelected.splice(
                      index,
                      1
                    );
                  }
                }
              }
            }
          });
        }
      });

      //imposto se il POI ha delle attività selezionate
      Array.prototype.forEach.call(tmpFilteredPOI, (poi) => {
        var poiHasActivitiesSelected = false;

        Array.prototype.forEach.call(poi.mis, (activity) => {
          if (activity.selected) {
            poiHasActivitiesSelected = true;
          }
        });

        poi.poiHasActivitiesSelected = poiHasActivitiesSelected;
      });

      Array.prototype.forEach.call(this.$store.state.aree, (area) => {
        var areaHasActivitiesSelected = false;

        Array.prototype.forEach.call(tmpFilteredPOI, (poi) => {
          if (
            poi.poiHasActivitiesSelected &&
            poi["geo:appartiene_a_area"][0]["display_title"] === area["o:title"]
          ) {
            areaHasActivitiesSelected = true;
          }
        });

        area.areaHasActivitiesSelected = areaHasActivitiesSelected;
      });

      for (var i = 0; i < this.filteredPOI.length; i++) {
        this.$set(this.filteredPOI, i, tmpFilteredPOI[i]);
      }

      this.initializeMarkersOfFilteredPOI();
    },

    //funzione chiamata quando si seleziona un'area
    checkArea(index, areaTitle) {
      store.commit("setSelectedArea", { areaTitle });
      //this.selectedArea = areaName;
    },

    //funzione chiamata quando si seleziona/deseleziona un interesse
    checkInterest(index, interestName) {
      var notSelectedPresent = false;
      Array.prototype.forEach.call(this.$store.state.interests, (interest) => {
        if (!interest.interestSelected) {
          notSelectedPresent = true;
        }
      });

      if (notSelectedPresent) {
        this.selectAllInterests = false;
      } else {
        this.selectAllInterests = true;
      }

      //filtro i POI in base agli interessi
      //this.filterPOIofCorrectInterests();
      this.filterActivitiesOfCorrectInterests();
      this.setPOIVisibilityWithInterestsSelected();

      //aggiorno i markers sulla mappa
      this.initializeMarkersOfFilteredPOI();
    },

    //funzione chiamata quando si seleziona/deseleziona una difficoltà
    checkDifficulty(index, difficultyName) {
      // var notSelectedPresent = false;
      // Array.prototype.forEach.call(
      //   this.$store.state.expertiseLevels,
      //   (difficultyLevel) => {
      //     if (!difficultyLevel.expertiseLevelSelected) {
      //       notSelectedPresent = true;
      //     }
      //   }
      // );

      // if (notSelectedPresent) {
      //   this.selectAllDifficulties = false;
      // } else {
      //   this.selectAllDifficulties = true;
      // }

      store.commit("setSelectedDifficultyFilter", { difficultyName });

      //filtro i POI in base alla difficoltà
      this.filterPOIofCorrectDifficulty();
      this.setPOIVisibilityWithInterestsSelected();

      //aggiorno i markers sulla mappa
      this.initializeMarkersOfFilteredPOI();
    },

    //funzione chiamata quando si seleziona/deseleziona un interesse
    checkActivityType(index, activityTypeName) {
      //filtro i POI in base ai tipi di attività

      var notSelectedPresent = false;
      Array.prototype.forEach.call(
        this.$store.state.activityType,
        (activityType) => {
          if (!activityType.activityTypeSelected) {
            notSelectedPresent = true;
          }
        }
      );

      if (notSelectedPresent) {
        this.selectAllActivityType = false;
      } else {
        this.selectAllActivityType = true;
      }

      //this.filterPOIofCorrectInterests();
      this.filterActivitiesOfCorrectActivityType();
      this.setPOIVisibilityWithInterestsSelected();

      //aggiorno i markers sulla mappa
      this.initializeMarkersOfFilteredPOI();
    },

    //funzione chiamata quando si seleziona/deseleziona "Select All" in difficulties
    selectAllDifficultiesFunctions() {
      this.selectAllDifficulties = !this.selectAllDifficulties;

      for (var i = 0; i < this.$store.state.expertiseLevels.length; i++) {
        this.$set(
          this.$store.state.expertiseLevels[i],
          "expertiseLevelSelected",
          this.selectAllDifficulties
        );
      }

      //filtro i POI in base alla difficoltà
      this.filterPOIofCorrectDifficulty();
      this.setPOIVisibilityWithInterestsSelected();

      //aggiorno i markers sulla mappa
      this.initializeMarkersOfFilteredPOI();
    },

    //funzione chiamata quando si seleziona/deseleziona "Select All" in interests
    selectAllInterestsFunctions() {
      this.selectAllInterests = !this.selectAllInterests;

      for (var i = 0; i < this.$store.state.interests.length; i++) {
        this.$set(
          this.$store.state.interests[i],
          "interestSelected",
          this.selectAllInterests
        );
      }

      //filtro i POI in base agli interessi
      //this.filterPOIofCorrectInterests();
      this.filterActivitiesOfCorrectInterests();
      this.setPOIVisibilityWithInterestsSelected();

      //aggiorno i markers sulla mappa
      this.initializeMarkersOfFilteredPOI();
    },

    //funziona chiamata quando si seleziona/deseleziona "Select All" in activity Type
    selectAllActivityTypeFunctions() {
      this.selectAllActivityType = !this.selectAllActivityType;

      for (var i = 0; i < this.$store.state.activityType.length; i++) {
        this.$set(
          this.$store.state.activityType[i],
          "activityTypeSelected",
          this.selectAllActivityType
        );
      }

      //filtro i POI in base agli interessi
      this.filterActivitiesOfCorrectActivityType();
      this.setPOIVisibilityWithInterestsSelected();

      //aggiorno i markers sulla mappa
      this.initializeMarkersOfFilteredPOI();
    },

    filterPOIofCorrectDifficulty() {
      //filtro i POI in base alla difficoltà
      Array.prototype.forEach.call(this.filteredPOI, (poi) => {
        var poiHasSomeActivitiesVisible = false;
        Array.prototype.forEach.call(poi.mis, (exp) => {
          var expHasCorrectExpertiseLevels = false;

          var difficultiesOfActivity = exp["geo:ha_difficolta"].map(
            (diff) => diff["display_title"]
          );

          // se store.state.selectedDifficultyFilter === null vuol dire che la pagina è stata aperta per la prima volta nella sessione
          if (
            store.state.selectedDifficultyFilter === null ||
            difficultiesOfActivity.includes(
              store.state.selectedDifficultyFilter
            ) ||
            exp["geo:ha_difficolta"][0]["display_title"] === "Per Tutti"
          ) {
            expHasCorrectExpertiseLevels = true;

            var interestOk = false;

            if (
              this.selectedInterests.length ===
              this.$store.state.allInterestsStore.length
            ) {
              poiHasSomeActivitiesVisible = true;
            } else {
              // Controllo se gli interessi dell'attività vanno bene
              Array.prototype.forEach.call(
                exp["geo:ha_interesse"],
                (interest) => {
                  if (
                    this.selectedInterests.includes(interest["display_title"])
                  ) {
                    interestOk = true;
                  }
                }
              );

              poiHasSomeActivitiesVisible = true && interestOk;
            }
          }

          //exp.activityVisibleWithFilters = expHasCorrectExpertiseLevels;
          exp.activityVisibleWithDifficultiesFilters =
            expHasCorrectExpertiseLevels;
        });

        poi.poiHasSomeActivitiesVisible = poiHasSomeActivitiesVisible;
      });
    },

    // filterPOIofCorrectInterests() {
    //   //filtro i POI in base agli interessi
    //   Array.prototype.forEach.call(this.filteredPOI, (poi) => {
    //     var poiHasCorrectInterests = false;

    //     Array.prototype.forEach.call(poi["geo:ha_interesse"], (interest) => {
    //       if (this.selectedInterests.includes(interest["display_title"])) {
    //         poiHasCorrectInterests = true;
    //       }
    //     });

    //     poi.poiVisibleWithFilters = poiHasCorrectInterests;
    //   });
    // },

    filterActivitiesOfCorrectInterests() {
      //filtro i POI in base alla difficoltà
      Array.prototype.forEach.call(this.filteredPOI, (poi) => {
        var poiHasSomeActivitiesVisible = false;
        Array.prototype.forEach.call(poi.mis, (exp) => {
          var expHasCorrectInterests = false;

          Array.prototype.forEach.call(exp["geo:ha_interesse"], (interest) => {
            if (this.selectedInterests.includes(interest["display_title"])) {
              expHasCorrectInterests = true;
              poiHasSomeActivitiesVisible = true;
            }
          });

          exp.activityVisibleWithInterestsFilters = expHasCorrectInterests;
        });

        poi.poiHasSomeActivitiesVisible = poiHasSomeActivitiesVisible;
      });
    },

    filterActivitiesOfCorrectActivityType() {
      //filtro i POI in base alla tipologia
      Array.prototype.forEach.call(this.filteredPOI, (poi) => {
        var poiHasSomeActivitiesVisible = false;

        Array.prototype.forEach.call(poi.mis, (exp) => {
          var expHasCorrectActivityType = false;

          Array.prototype.forEach.call(
            exp["geo:ha_tipologia_attivita"],
            (actType) => {
              if (
                this.selectedActivityType.includes(actType["display_title"])
              ) {
                expHasCorrectActivityType = true;
                poiHasSomeActivitiesVisible = true;
              }
            }
          );

          exp.activityVisibleWithActivityTypeFilters =
            expHasCorrectActivityType;
          poi.poiHasSomeActivitiesVisible = poiHasSomeActivitiesVisible;
        });
      });
    },

    setPOIVisibilityWithInterestsSelected() {
      var tmpFilteredPOI = this.filteredPOI;
      var self = this;

      for (var i = 0; i < tmpFilteredPOI.length; i++) {
        var poiInterests = tmpFilteredPOI[i]["geo:ha_interesse"];
        var poiInterestsName = poiInterests.map(
          (interest) => interest.display_title
        );
        var poiHasCorrectInterests = false;
        var poiHasActivitiesVisible = false;

        Array.prototype.forEach.call(poiInterestsName, (interest) => {
          if (this.selectedInterests.includes(interest)) {
            poiHasCorrectInterests = true;
          }
        });

        if (!poiHasCorrectInterests) {
          Array.prototype.forEach.call(tmpFilteredPOI[i].mis, (activity) => {
            if (
              activity.activityVisibleWithInterestsFilters &&
              activity.activityVisibleWithDifficultiesFilters &&
              activity.activityVisibleWithActivityTypeFilters
            ) {
              poiHasActivitiesVisible = true;
            }
          });
        }

        this.$set(
          tmpFilteredPOI[i],
          "poiVisibleWithFilters",
          poiHasCorrectInterests || poiHasActivitiesVisible
        );
      }

      for (var i = 0; i < this.filteredPOI.length; i++) {
        this.$set(this.filteredPOI, i, tmpFilteredPOI[i]);
      }
    },
    goBack() {
      router.go(-1);
    },
    getMilliseconds(minutesString) {
      var minutesInt = parseInt(minutesString);
      return minutesInt * 60000;
    },

    goToItinerariPredefinitiPage() {
      router.push({
        name: "elencopercorsi",
      });
    },

    makeQueryVROOM(vroomObject, areaName, areaID) {
      var self = this;

      $.ajax({
        type: "POST",
        data: JSON.stringify(vroomObject),
        url: "https://vroom.geodidalab.unito.it/",
        contentType: "application/json",
      })
        .done(function (res) {
          self.createItineraryObject(res, areaName, areaID, vroomObject);
        })
        .fail(function () {
          self.modals.errorGettingSottoitinerario = true;
        })
        .always(function () {
          //alert("complete");
        });
    },

    createItineraryObject(vroomResponseObject, areaName, areaID, vroomObject) {
      var vroomRoutesSteps = vroomResponseObject.routes[0].steps;

      var itineraryObject = {
        name: "Itinerario_" + areaName,
        areaName: areaName,
        areaID: areaID,
        poi: null,
        totalTimeMilliseconds: 0,
      };

      //TODO: prendere l'unico step con un setup e sottrarlo al tempo totale

      var poiArray = [];
      var activityInPOIArray = [];

      var stepWithSetupMoreThanZero =
        vroomResponseObject.routes[0].steps.filter((step) => step.setup > 0);

      Array.prototype.forEach.call(
        vroomResponseObject.routes[0].steps,
        (step, index) => {
          var activity = step;

          if (activity.type === "start") {
            activity.description = "Punto di partenza";
            activity.poiName = "Punto di partenza";
            activity.activityName = "Punto di partenza";

            poiArray.push({
              poiName: "Punto di partenza",
              location: activity.location,
              activitiesInPOI: [],
            });
          } else if (activity.type === "end") {
            activity.description = "Punto di arrivo";
            activity.poiName = "Punto di arrivo";
            activity.activityName = "Punto di arrivo";

            poiArray.push({
              poiName: "Punto di arrivo",
              location: activity.location,
              activitiesInPOI: [],
            });
          } else {
            var fields = activity.description.split("_");

            var poi = poiArray.filter((poi) => poi.poiName === fields[0]);

            var poiID = 0;
            if (fields[1].includes("Visita")) {
              poiID = fields[2];
            } else {
              poiID = fields[3];
            }

            if (poi.length === 0) {
              poiArray.push({
                poiID: poiID,
                poiName: fields[0],
                location: activity.location,
                activitiesInPOI: [],
              });
            }

            // activity.poiName = fields[0];

            // var poiID = 0;
            // if (fields[1].includes("Visita")) {
            //   activity.activityName = "Visita " + fields[0]; //prima assegnavo fields[1];
            //   activity.poiID = fields[2];
            //   poiID = fields[2];
            // } else {
            //   activity.activityName = fields[1]; //prima assegnavo fields[1];
            //   activity.poiID = fields[3];
            //   poiID = fields[3];
            //   activity.activityType = fields[2];
            // }

            // //se non esiste già un oggetto poi con lo stesso nome (ovvero rappresentante lo stesso poi), allora lo aggiungo
            // var poiWithSameName = poiArray.filter(
            //   (poi) => poi.poiName === fields[0]
            // );
            // if (poiWithSameName.length === 0) {
            //   poiArray.push({
            //     poiID: poiID,
            //     poiName: fields[0],
            //     location: activity.location,
            //   });
            // }
          }

          // activity.index = index;
          // activity.serviceDurationMinutes = activity.service / 60000;
          // activity.setupTimeMinutes = activity.setup / 60000;

          // activityInPOIArray.push(activity);
        }
      );

      Array.prototype.forEach.call(
        vroomResponseObject.routes[0].steps,
        (step, index) => {
          var activity = step;

          if (activity.type === "start") {
            //DO NOTHING
          } else if (activity.type === "end") {
            //DO NOTHING
          } else {
            var fields = activity.description.split("_");

            activity.poiName = fields[0];

            var poiID = 0;
            if (fields[1].includes("Visita")) {
              activity.activityName = "Visita " + fields[0]; //prima assegnavo fields[1];
              activity.poiID = fields[2];
              poiID = fields[2];
            } else {
              activity.activityName = fields[1]; //prima assegnavo fields[1];
              activity.poiID = fields[3];
              poiID = fields[3];
              activity.activityType = fields[2];
            }

            //se non esiste già un oggetto poi con lo stesso nome (ovvero rappresentante lo stesso poi), allora lo aggiungo
            var poi = poiArray.filter((poi) => poi.poiName === fields[0]);

            activity.index = index;
            activity.serviceDurationMinutes = activity.service / 60000;

            if (activity.setup !== 0) {
              activity.setupTimeMinutes = activity.setup / 60000;
            } else if (!activity.activityName.includes("Visita")) {
              //TODO: SETUP TIME QUA
              var setupTime = this.getActivitySetupTime(activity.activityName);

              activity.setupTimeMinutes = setupTime;

              if (activity.setup === 0) {
                activity.setup = this.getMilliseconds(setupTime.toString());
                vroomResponseObject.routes[0].setup += activity.setup;
              }
            }

            poi[0].activitiesInPOI.push(activity);
          }
        }
      );

      //purtroppo vroom mette 0 cone setup time a tutte le attività dopo la prima
      //il tempo di arrival dell'ultimo punto comprende pero' il tempo di setup di ogni prima attività di un nuovo POI
      //quindi devo sottrarre il tempo di setup di ogni attività è la prima di un POI
      //questo perchè precedentemente è stato conteggiato correttamente il tempo di setup di ogni attività e quello totale della rotta
      //con questo calcolo non riconteggiamo tempi già conteggiati

      var correctTotalTimeMillieconds =
        vroomRoutesSteps[vroomRoutesSteps.length - 1].arrival +
        vroomResponseObject.routes[0].setup; //vroomResponseObject.summary.service,;

      Array.prototype.forEach.call(stepWithSetupMoreThanZero, (step, index) => {
        correctTotalTimeMillieconds -= step.setup;
      });

      itineraryObject.totalTimeMilliseconds = correctTotalTimeMillieconds;

      itineraryObject.poi = poiArray;

      Array.prototype.forEach.call(itineraryObject.poi, (poi, index) => {

        var activitiesInPOI = JSON.parse(JSON.stringify(poi.activitiesInPOI));

        //metto la visita come prima attività
        var indexOfVisit = -1;
        var toIndex = 0;
        Array.prototype.forEach.call(activitiesInPOI, (act) => {
          if (act.activityName.includes("Visita")) {
            indexOfVisit = activitiesInPOI.indexOf(act);
          }
        });

        if (indexOfVisit > 0) {
          const element = activitiesInPOI.splice(indexOfVisit, 1)[0];
          activitiesInPOI.splice(toIndex, 0, element);
        }

        poi.activitiesInPOI = activitiesInPOI;
      });

      var unassignedArray = [];

      //Controllo se non è stato assegnato qualcosa
      if (vroomResponseObject.unassigned.length > 0) {
        //Qualcosa non è stao assegnato!!!!
        Array.prototype.forEach.call(
          vroomResponseObject.unassigned,
          (unassigned) => {
            var unassignedJob = vroomObject.jobs.filter(
              (job) => job.id === unassigned.id
            );
            unassignedArray.push(unassignedJob[0]);
          }
        );
      }

      itineraryObject.unassignedArray = unassignedArray;

      if (this.$store.getters.getCustomTimeSlot) {

        itineraryObject.preferredPartOfDay =
          this.$store.getters.getCustomTimeSlot;
      } else {
        itineraryObject.preferredPartOfDay =
          this.$store.state.preferredPartOfDay;
      }

      var timeAvailable = this.$store.state.timeAvailable;

      this.$store.state.itinerarioInCreazione = itineraryObject;
      this.totalItinerary.push(itineraryObject);
    },

    expandText(id, expandIcon, collapseIcon, cardHeaderID) {
      $("#" + id).addClass("truncated");
      $("#" + expandIcon).hide();
      $("#" + collapseIgetcon).show();
    },

    collapseText(id, expandIcon, collapseIcon) {
      $("#" + id).removeClass("truncated");
      $("#" + expandIcon).show();
      $("#" + collapseIcon).hide();
    },

    getActivitySetupTime(activityName) {
      var activity = this.$store.state.esperimenti.filter(
        (exp) => exp["o:title"] === activityName
      );

      if (activity.length !== 0) {
        var activityOrganizationTime = activity["geo:Durata_organizzazione"]
          ? parseInt(activity["geo:Durata_organizzazione"][0]["@value"])
          : config.omekaIDs.defaultOrganizationTime;

        return activityOrganizationTime;
      } else {
        return config.omekaIDs.defaultOrganizationTime;
      }
    },

    openPOIactivities(cardHeaderID, event) {
      //se event.target.tagName.toLowerCase() è === 'a' o === 'i' allora ho cliccato su "mostra descrizione" e non si deve aprire il collapse delle attività
      if (
        event.target.tagName.toLowerCase() !== "a" &&
        event.target.tagName.toLowerCase() !== "i"
      ) {
        var header = $("#" + cardHeaderID);
        //getting the next element
        var content = header.next();

        //open up the content needed - toggle the slide- if visible, slide up, if not slidedown.
        content.slideToggle(250, function () {
          //execute this after slideToggle is done
          //change text of header based on visibility of content div
        });
      }
    },

    permute(nums) {
      var result = [];
      var backtrack = (i, nums) => {
        if (i === nums.length) {
          result.push(nums.slice());
          return;
        }
        for (let j = i; j < nums.length; j++) {
          [nums[i], nums[j]] = [nums[j], nums[i]];
          backtrack(i + 1, nums);
          [nums[i], nums[j]] = [nums[j], nums[i]];
        }
      };
      backtrack(0, nums);
      return result;
    },

    arrayEquals(a, b) {
      return (
        Array.isArray(a) &&
        Array.isArray(b) &&
        a.length === b.length &&
        a.every((val, index) => val === b[index])
      );
    },

    catchCreateItinerary() {
      this.incrementStep();
    },

    openAreasCollapse(e) {
      var content = e.srcElement.nextElementSibling;
      if (content.style.maxHeight) {
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
      }

      this.areasCollapseIsOpen = !this.areasCollapseIsOpen;
    },

    openInterestsCollapse(e) {
      var content = e.srcElement.nextElementSibling;
      if (content.style.maxHeight) {
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
      }

      this.interestsCollapseIsOpen = !this.interestsCollapseIsOpen;
    },

    openDifficultiesCollapse(e) {
      var content = e.srcElement.nextElementSibling;
      if (content.style.maxHeight) {
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
      }

      this.difficultiesCollapseIsOpen = !this.difficultiesCollapseIsOpen;
    },

    openActivityTypesCollapse(e) {
      var content = e.srcElement.nextElementSibling;
      if (content.style.maxHeight) {
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
      }

      this.activityTypeCollapseIsOpen = !this.activityTypeCollapseIsOpen;
    },
    getTotalTimeOfItinerary() {
      var areas = [];

      var totalTime = 0;

      //Recupero le aree a cui appartengono i sottoitinerari
      Array.prototype.forEach.call(
        this.$store.state.sottoitinerari,
        (sottoitinerario) => {
          var areaID = sottoitinerario.areaID;
          areas.push(areaID);

          totalTime += sottoitinerario.totalTimeMilliseconds;
        }
      );

      //Sommo i tempi di tragitto da un'area all'altra
      var travellingTime = 0;
      for (var i = 0; i < this.$store.state.sottoitinerari.length - 1; i++) {
        var distancesFromAreaOfIndexI =
          this.$store.state.costMatricesTimeBetweenAreas.filter(
            (area) =>
              parseInt(area.AreaID) ===
              this.$store.state.sottoitinerari[i].areaID
          );
        var distancesFromAreaOfIndexIPlus1 =
          this.$store.state.costMatricesTimeBetweenAreas.filter(
            (area) =>
              parseInt(area.AreaID) ===
              this.$store.state.sottoitinerari[i + 1].areaID
          );

        var destinationAreaString = String(
          this.$store.state.sottoitinerari[i + 1].areaID
        );

        var areaNameIndexI = distancesFromAreaOfIndexI[0]
          ? distancesFromAreaOfIndexI[0].AreaName
          : this.$store.state.sottoitinerari[i].areaName;
        var areaNameIndexIPlus1 = distancesFromAreaOfIndexIPlus1[0]
          ? distancesFromAreaOfIndexIPlus1[0].AreaName
          : this.$store.state.sottoitinerari[i + 1].areaName;
        var timeBetweenAreas =
          distancesFromAreaOfIndexI[0] &&
          distancesFromAreaOfIndexI[0][destinationAreaString]
            ? distancesFromAreaOfIndexI[0][destinationAreaString]
            : config.omekaIDs.defaultTravelTimeBetweenPOIs * 60000;

        travellingTime += timeBetweenAreas;
      }

      totalTime += travellingTime;

      return totalTime;
    },
    // Convert a time in hh:mm format to minutes
    timeToMins(time) {
      var b = time.split(":");
      return b[0] * 60 + +b[1];
    },

    // Convert minutes to a time in format hh:mm
    // Returned value is in range 00  to 24 hrs
    timeFromMins(mins) {
      function z(n) {
        return (n < 10 ? "0" : "") + n;
      }
      var h = ((mins / 60) | 0) % 24;
      var m = mins % 60;
      return z(h) + ":" + z(m);
    },

    // Add two times in hh:mm format
    addTimes(t0, t1) {
      return this.timeFromMins(this.timeToMins(t0) + this.timeToMins(t1));
    },

    findPositionIndexForLunch() {
      /*
        var index = -1;
        var currentTime = "09:30" //tempo iniziale
        vat sumTimeMs = 0;
        per ogni sottoitinerario:
          per ogni poi:
            per ogni attività:
              sumTimeMs += attività.duration
              stringTime = date(sumTimeMs)
              currentTime = addTimes(currentTime, stringTime)
              if(currentTime > 12:00)
                return index

            timeToNextPoi = getTimeToNextpoi() //milliseconds
            stringTime = date(timeToNextPoi)
            currentTime = addTimes(currentTime, stringTime)
            if(currentTime > 12:00)
              return index

          timeToNextArea = getTimeToNextArea() //milliseconds
          stringTime = date(timeToNextArea)
          currentTime = addTimes(currentTime, stringTime)
          if(currentTime > 12:00)
            return index

        return -1
      */

      var index = -1;

      var customTimeSlot = this.$store.getters.getCustomTimeSlot;
      var currentTime = customTimeSlot.split("-")[0]; //tempo iniziale
      var sumTimeMs = 0;

      console.log("CURRENT TIME: " + currentTime); 

      for (var i = 0; i < this.$store.state.sottoitinerari.length; i++) {
        var sottoitinerario = this.$store.state.sottoitinerari[i];
        for (var j = 0; j < sottoitinerario.poi.length; j++) {
          var poi = sottoitinerario.poi[j];

          console.log("POI: " + poi.poiName); 
          console.log("CURRENT TIME: " + currentTime); 


          if (
            poi.poiName !== "Punto di partenza" &&
            poi.poiName !== "Punto di arrivo"
          ) {
            for (var k = 0; k < poi.activitiesInPOI.length; k++) {

              var activity = poi.activitiesInPOI[k];

              sumTimeMs += activity.service;
              sumTimeMs += activity.setup;


              var stringTimeService = new Date(activity.service + activity.setup)
                .toISOString()
                .slice(11, 16);

              currentTime = this.addTimes(currentTime, stringTimeService);

              //indice trovato tra le attività
              var currentTimeSpit = currentTime.split(":");

              var currentTimeHours = parseInt(currentTimeSpit[0]);
              var currentTimeMinutes = parseInt(currentTimeSpit[1]);


              console.log("ACTIVITY: " + activity.activityName); 
              console.log("CURRENT TIME: " + currentTime); 

              if (currentTime + ":00" > "13:30:00") {
                console.log("ESCO QUA 1");
                console.log("sottoitinerario: " + i);
                console.log("poi: " + j);
                console.log("activity: " + k);
                //dalle 13 in poi
                return {
                  indexSottoitinerario: i,
                  indexPoi: j === 1 ? j + 1 : j,
                  indexActivity: k + 1,
                };
              }
            }

            if (
              j < sottoitinerario.poi.length - 1 &&
              sottoitinerario.poi[j + 1] !== undefined &&
              sottoitinerario.poi[j + 1].poiName !== "Punto di arrivo"
            ) {
              var timeToNextPoi = this.getTimeToNextPOI(
                poi,
                sottoitinerario.poi[j + 1]
              ); //milliseconds

              var stringTimeToNextPOI = new Date(timeToNextPoi)
                .toISOString()
                .slice(11, 16);

                
              currentTime = this.addTimes(currentTime, stringTimeToNextPOI);

              console.log("MI SPOSTO DA: " + poi.poiName + " A " + sottoitinerario.poi[j + 1].poiName);
              console.log("CURRENT TIME: " + currentTime); 

              //indice trovato tra i poi
              var currentTimeSpit = currentTime.split(":");
              var currentTimeHours = parseInt(currentTimeSpit[0]);
              var currentTimeMinutes = parseInt(currentTimeSpit[1]);

              if (currentTime + ":00" > "13:30:00") {
                console.log("ESCO QUA 2");
                console.log("sottoitinerario: " + i);
                console.log("poi: " + j);
                console.log("activity: " + k);
                //dalle 13 in poi
                return {
                  indexSottoitinerario: i,
                  indexPoi: j === 1 ? j + 1 : j,
                  indexActivity: k,
                };
              }
            }
          }
        }

        if (i < this.$store.state.sottoitinerari.length - 1) {
          var timeToNextArea = this.getTimeToNextArea(
            sottoitinerario,
            this.$store.state.sottoitinerari[i + 1]
          ); //milliseconds

          var stringTimeToNextArea = new Date(timeToNextArea)
            .toISOString()
            .slice(11, 16);

          currentTime = this.addTimes(currentTime, stringTimeToNextArea);

          // console.log("MI SPOSTO DA: " + poi.poiName + " A " + sottoitinerario.poi[j + 1].poiName);
              console.log("MI SPOSTO DI AREA CURRENT TIME: " + currentTime); 

          if (j === sottoitinerario.poi.length) {
            j = j - 2; //in questo modo il pranzo verrà messo dopo l'ultimo poi buono
          }

          //indice trovato tra le aree
          var currentTimeSpit = currentTime.split(":");
          var currentTimeHours = parseInt(currentTimeSpit[0]);
          var currentTimeMinutes = parseInt(currentTimeSpit[1]);

          if (currentTime + ":00" > "13:30:00") {
            console.log("ESCO QUA 3");
            console.log("sottoitinerario: " + i);
                console.log("poi: " + j);
                console.log("activity: " + k);
            //dalle 13 in poi
            return {
              indexSottoitinerario: i,
              indexPoi: j === 1 ? j + 1 : j,
              indexActivity: k,
            };
          }
        }
      }

      return null;
    },

    getTimeToNextPOI(poi, nextPOI) {
      var timesFromPOI = store.state.costMatricesTimeBetweenPOI.filter(
        (p) => p.PoiID === poi.poiID
      );

      // var timesDestinationPOI = store.state.costMatricesTimeBetweenPOI.filter(
      //   (p) => p.PoiID === poi.poiID
      // );

      var timeMillis = config.omekaIDs.defaultTravelTimeBetweenPOIs * 60000; //minuti di default di spostamento tra un poi e l'altro

      if (timesFromPOI[0]) {
        timeMillis = timesFromPOI[0][nextPOI.poiID];
      }

      if (timeMillis === "-1") {
        //se il tempo è -1 vuol dire che non è stato possibile calcolare il tempo di spostamento tra i due POI e usiamo quello di default
        timeMillis = config.omekaIDs.defaultTravelTimeBetweenPOIs * 60000;
      }

      return timeMillis;
    },

    getTimeToNextArea(area, nextArea) {
      var distancesFromAreaOfIndexI =
        this.$store.state.costMatricesTimeBetweenAreas.filter(
          (a) => parseInt(a.AreaID) === area.areaID
        );

      var destinationAreaString = String(nextArea.areaID);

      var timeBetweenAreas =
        distancesFromAreaOfIndexI[0] &&
        distancesFromAreaOfIndexI[0][destinationAreaString]
          ? distancesFromAreaOfIndexI[0][destinationAreaString]
          : config.omekaIDs.defaultTravelTimeBetweenPOIs * 60000;

      return timeBetweenAreas;
    },
  },
  computed: {
    isLarge() {
      return this.windowWidth >= 768;
    },

    firstThreeInterests() {
      return this.$store.state.interests.slice(0, 3);
    },

    remainingInterests() {
      return this.$store.state.interests.slice(
        3,
        this.$store.state.interests.length
      );
    },

    loadedMatrixPOI() {
      return store.state.vroomCostMatricesTimeBetweenPOI !== null;
    },

    loadedMatrixAreas() {
      return store.state.costMatricesTimeBetweenAreas !== null;
    },

    loadedMatrixForVROOM() {
      return store.state.costMatricesTimeBetweenPOI !== null;
    },
    areasLength() {
      return store.state.aree.length;
    },
    setAreasSelected() {
      var uniqueArray = this.$store.state.areasWithSomethingSelected.filter(
        function (item, pos, self) {
          return self.indexOf(item) == pos;
        }
      );
      return uniqueArray;
    },

    areasWithSomePOIinside() {
      var arrayOfareasWithSomePOI = [];

      Array.prototype.forEach.call(this.$store.state.aree, (area) => {
        var poiInArea = this.filteredPOI.filter(
          (poi) =>
            poi["geo:appartiene_a_area"][0]["value_resource_id"] ===
            area["o:id"]
        );
        if (poiInArea.length > 0) {
          //l'area ha almeno un POI
          arrayOfareasWithSomePOI.push(area);
        }
      });

      return arrayOfareasWithSomePOI;
    },

    centerMap() {
      var sumLat = 0;
      var sumLng = 0;

      Array.prototype.forEach.call(this.markers, (marker) => {
        sumLat += marker.marker["_latlng"].lat;
        sumLng += marker.marker["_latlng"].lng;
      });

      var middleLat = sumLat / this.markers.length;
      var middleLng = sumLng / this.markers.length;

      if (isNaN(middleLat) || isNaN(middleLng)) {
        return [45.47724690648075, 7.888264286334166];
      } else {
        return [middleLat, middleLng];
      }
    },

    correctPercent() {
      if (this.$store.state.remainingTimeAvailable === 0) {
        //se non c'è più tempo a disposizione
        return 100;
      } else if (
        this.$store.state.remainingTimeAvailable ===
        this.$store.state.timeAvailable.milliseconds
      ) {
        //se il tempo a disposizione è massimo
        return 0;
      } else {
        var diff =
          this.$store.state.timeAvailable.milliseconds -
          this.$store.state.remainingTimeAvailable;
        var perc = (diff * 100) / this.$store.state.timeAvailable.milliseconds;
        if (perc <= 100) {
          return Math.ceil(perc);
        } else {
          return 100;
        }
      }
    },

    msToTime() {
      if (this.$store.state.remainingTimeAvailable > 0) {
        var milliseconds = Math.floor(
            (this.$store.state.remainingTimeAvailable % 1000) / 100
          ),
          seconds = Math.floor(
            (this.$store.state.remainingTimeAvailable / 1000) % 60
          ),
          minutes = Math.floor(
            (this.$store.state.remainingTimeAvailable / (1000 * 60)) % 60
          ),
          hours = Math.floor(
            (this.$store.state.remainingTimeAvailable / (1000 * 60 * 60)) % 24
          );

        hours = hours < 10 ? "0" + hours : hours;
        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;

        var timeObject = {
          hours: hours,
          minutes: minutes,
          seconds: seconds,
          milliseconds: this.$store.state.remainingTimeAvailable,
        };

        return timeObject;
      } else {
        var timeObject = {
          hours: 0,
          minutes: 0,
          seconds: 0,
          milliseconds: 0,
        };

        return timeObject;
      }
    },

    selectedActivityType() {
      var mappedActivityType = this.$store.state.activityType
        .filter((actType) => actType.activityTypeSelected)
        .map((actType) => actType.activityTypeName);

      if (mappedActivityType.length === 0) {
        return store.state.allActivityTypesStore; //this.allActivityType;
      } else {
        return mappedActivityType;
      }
    },

    selectedInterests() {
      var mappedInterests = this.$store.state.interests
        .filter((interest) => interest.interestSelected)
        .map((interest) => interest.interestName);

      if (mappedInterests.length === 0) {
        return store.state.allInterestsStore; //this.allInterests;
      } else {
        return mappedInterests;
      }
    },

    selectedDifficulties() {
      var mappedDifficulties = this.$store.state.expertiseLevels
        .filter((expLevel) => expLevel.expertiseLevelSelected)
        .map((expLevel) => expLevel.expertiseLevelName);

      if (mappedDifficulties.length === 0) {
        return store.state.allDifficultiesStore; //this.allDifficulties;
      } else {
        return mappedDifficulties;
      }
    },

    somePOIVisible() {
      return (
        this.filteredPOI.filter((poi) => poi.poiVisibleWithFilters).length > 0
      );
    },

    somePOIVisibleInCurrentArea() {
      return (
        this.filteredPOI
          .filter(
            (poi) =>
              poi["geo:appartiene_a_area"][0]["display_title"] ===
              this.$store.getters.selectedAreaCreateItinerary
          )
          .filter((poi) => poi.poiVisibleWithFilters).length > 0
      );
    },

    allActivitiesLoaded() {
      return (
        this.filteredPOI.filter((poi) => poi.mis === undefined).length === 0
      );
    },

    someActivitiesSelected() {
      return this.$store.getters.activitiesSelectedList.length > 0;
    },

    bestPath() {
      var bestTime = 9999999999;
      var areas = [...new Set(this.$store.state.areasWithSomethingSelected)];
      var permutation = this.permute(areas);

      for (var k = 0; k < permutation.length; k++) {
        //Sommo i tempi di tragitto da un'area all'altra
        var areas = permutation[k];
        var time = 0;
        for (var i = 0; i < areas.length - 1; i++) {
          var distancesFromAreaOfIndexI =
            this.$store.state.costMatricesTimeBetweenAreas.filter(
              (area) => parseInt(area.AreaID) === areas[i]
            );
          var destinationAreaString = String(areas[i + 1]);

          if (
            distancesFromAreaOfIndexI.length === 0 ||
            distancesFromAreaOfIndexI[0][destinationAreaString] === undefined
          ) {
            //SOMMO I MINUTI DI DEFAULT DI SPOSTAMENTO TRA LE AREE
            time += config.omekaIDs.defaultTravelTimeBetweenAreas * 60000;
          } else {
            time += distancesFromAreaOfIndexI[0][destinationAreaString]; //nella matrice i valori sono espressi in millisecondi!
          }
        }

        if (time < bestTime) {
          bestTime = time;
        }
      }

      // se abbiamo solo un'area o 0 non c'è tempo di spostamento tra un'area e l'altra
      if (permutation.length <= 1) {
        bestTime = 0;
      }

      var numberOfPOI = 0;

      Array.prototype.forEach.call(areas, (area) => {
        var filteredActivities =
          this.$store.getters.activitiesSelectedList.filter(
            (act) =>
              act["geo:appartiene_a_area"][0]["value_resource_id"] === area
          );

        var mapPOInamesOfActivities = filteredActivities.map(
          (act) => act.poi["geo:Titolo_it"][0]["@value"]
        );

        var poiNames = [...new Set(mapPOInamesOfActivities)];

        if (poiNames.length > 1) {
          //se ho più di un POI nella stessa area mi sposto, altrimenti non c'è tempo di spostamento nella stessa area
          numberOfPOI += poiNames.length - 1;
        }
      });

      var timesBetweenPOI =
        numberOfPOI * (config.omekaIDs.meanTimeTravelBetweenPOI * 60000);

      if (timesBetweenPOI > 0) {
        return (bestTime += timesBetweenPOI);
      }

      return bestTime;
    },
    numberOfResultVisibleWIthFilters() {
      var numberOfPOIvisible = 0;
      var numberOfActivityVisible = 0;

      //filtro i POI in base alla tipologia
      Array.prototype.forEach.call(this.filteredPOI, (poi) => {
        if (poi.poiVisibleWithFilters) {
          numberOfPOIvisible += 1;
        }

        if (poi.poiHasSomeActivitiesVisible) {
          Array.prototype.forEach.call(poi.mis, (exp) => {
            if (
              exp.activityVisibleWithActivityTypeFilters &&
              exp.activityVisibleWithDifficultiesFilters &&
              exp.activityVisibleWithInterestsFilters
            ) {
              numberOfActivityVisible += 1;
            }
          });
        }
      });

      return [numberOfPOIvisible, numberOfActivityVisible];
    },
    numberOfResultVisibleWithFiltersInSelectedArea() {
      var obj = {};

      Array.prototype.forEach.call(this.$store.state.aree, (area) => {
        var numberOfPOIvisible = 0;
        var numberOfActivityVisible = 0;

        //filtro i POI in base alla tipologia
        Array.prototype.forEach.call(this.filteredPOI, (poi) => {
          if (
            poi["geo:appartiene_a_area"][0]["display_title"] === area["o:title"]
          ) {
            if (poi.poiVisibleWithFilters) {
              numberOfPOIvisible += 1;
            }

            if (poi.poiHasSomeActivitiesVisible) {
              Array.prototype.forEach.call(poi.mis, (exp) => {
                if (
                  exp.activityVisibleWithActivityTypeFilters &&
                  exp.activityVisibleWithDifficultiesFilters &&
                  exp.activityVisibleWithInterestsFilters
                ) {
                  numberOfActivityVisible += 1;
                }
              });
            }
          }
        });

        obj[area["o:title"]] = [numberOfPOIvisible, numberOfActivityVisible];
      });

      return obj;
    },
  },

  watch: {
    difficultyLevelsLoaded(newValue, oldValue) {
      if (newValue) {
        this.filterPOIofCorrectDifficulty();
      }
    },
    interestsLoaded(newValue, oldValue) {
      if (newValue) {
        this.selectAllInterests =
          this.$store.state.interests.filter(
            (interest) => interest.interestSelected
          ).length === store.state.allInterestsStore.length
            ? true
            : false;

        this.filterActivitiesOfCorrectInterests();
      }
    },
    activityTypeLoaded(newValue, oldValue) {
      if (newValue) {
        this.selectAllActivityType =
          this.$store.state.activityType
            .filter((actType) => actType.activityTypeSelected)
            .map((actType) => actType.activityTypeName).length ===
          store.state.allActivityTypesStore.length
            ? true
            : false;

        this.filterActivitiesOfCorrectActivityType();
      }
    },
    selectedInterests(newValue, oldValue) {
      if (newValue.length > 0) {
        this.setPOIVisibilityWithInterestsSelected();
        this.poiLoaded = true;
      }
    },
    areasLength(newValue, oldValue) {
      if (newValue !== 0) {
        //this.selectedArea = store.state.aree[0]["o:title"];
        var areaTitle = store.state.aree[0]["o:title"];
        store.commit("setSelectedArea", { areaTitle });
      }
    },
    bestPath(newValue, oldValue) {
      this.$store.state.remainingTimeAvailable += oldValue;
      this.$store.state.remainingTimeAvailable -= newValue;
    },
    setAreasSelected(newValue, oldValue) {
      var perm = this.permute(newValue);
      var costoTotale = 9999999999;
      var bestPath = [];

      Array.prototype.forEach.call(perm, (permutation) => {
        var cost = 0;

        for (var i = 0; i < permutation.length - 1; i++) {
          var distancesFromAreaOfIndexI =
            this.$store.state.costMatricesTimeBetweenAreas.filter(
              (area) => parseInt(area.AreaID) === permutation[i]
            );
          var destinationAreaString = String(permutation[i + 1]);

          if (
            distancesFromAreaOfIndexI.length === 0 ||
            distancesFromAreaOfIndexI[0][destinationAreaString] === undefined
          ) {
            //SOMMO I MINUTI DI DEFAULT DI SPOSTAMENTO TRA LE AREE
            cost += config.omekaIDs.defaultTravelTimeBetweenAreas * 60000;
          } else {
            cost += distancesFromAreaOfIndexI[0][destinationAreaString];
          }
        }

        if (cost < costoTotale) {
          costoTotale = cost;
          bestPath = permutation;
        }
      });

      if (bestPath === []) {
        costoTotale = 0;
      }

      this.timeBetweenAreas = costoTotale;
      this.bestPathBetweenAreas = bestPath;
    },
    totalItinerary(newValue, oldValue) {
      var numbersOfAreasWithSomethingSelected = [
        ...new Set(this.$store.state.areasWithSomethingSelected),
      ];

      if (numbersOfAreasWithSomethingSelected.length !== 0) {
        if (numbersOfAreasWithSomethingSelected.length === newValue.length) {
          var itineraryAlreadyExist = false;
          var itineraryCode = null;

          var sortOrder = [];
          sortOrder.length = this.bestPathBetweenAreas.length;
          for (var i = 0; i < this.bestPathBetweenAreas.length; i++) {
            sortOrder[i] = "Itinerario_" + this.bestPathBetweenAreas[i];
          }

          var self = this;

          newValue.sort(function (a, b) {
            return (
              self.bestPathBetweenAreas.indexOf(a.areaID) -
              self.bestPathBetweenAreas.indexOf(b.areaID)
            );
          });

          this.$store.state.sottoitinerari = newValue;

          //store.state.itinerarioPredefinito = this.itinerari[index];
          store.commit("setItinerarioVROOM", {
            itinerarioVROOM: newValue,
          });

          if (this.$store.getters.viewFeaturesProgettoTesi) {
            var totalTimeOfItinerary = this.getTotalTimeOfItinerary();

            var stringHourAndMinutes = new Date(totalTimeOfItinerary)
              .toISOString()
              .slice(11, 16);

            var positionIndexForLunch = this.findPositionIndexForLunch();

            this.$store.commit("positionIndexForLunch", {
              positionIndexForLunch,
            });

            // var customTimeSlot = this.$store.getters.getCustomTimeSlot;
            // var customTimeSlotStart = customTimeSlot.split("-")[0];
            // var customTimeSlotStartHour = parseInt(
            //   customTimeSlotStart.split(":")[0]
            // );
            // var customTimeSlotStartMinute = parseInt(
            //   customTimeSlotStart.split(":")[1]
            // );

            // var timeEndHourAndMinutes = this.addTimes(
            //   customTimeSlotStart,
            //   stringHourAndMinutes
            // );

            // var customTimeSlotEndHour = parseInt(
            //   timeEndHourAndMinutes.split(":")[0]
            // );
            // var customTimeSlotEndMinute = parseInt(
            //   timeEndHourAndMinutes.split(":")[1]
            // );

            //TODO: RICONTROLLARE BENE QUESTO IF
            // if (customTimeSlotStartHour <= 13 && customTimeSlotEndHour >= 13) {

            //   router.push({
            //     name: "sceltapranzo",
            //     params: { step: 0, itineraryAlreadyExist, itineraryCode },
            //     query: { type: 0 },
            //   });
            // } else {

            //   router.push({
            //     name: "sceltaopzioni",
            //     params: { step: 0, itineraryAlreadyExist, itineraryCode },
            //     query: { type: 0 },
            //   });
            // }

            if (positionIndexForLunch !== null) {
              router.push({
                name: "sceltapranzo",
                params: { step: 0, itineraryAlreadyExist, itineraryCode },
                query: { type: 0 },
              });
            } else {
              router.push({
                name: "sceltaopzioni",
                params: { step: 0, itineraryAlreadyExist, itineraryCode },
                query: { type: 0 },
              });
            }
          } else {
            router.push({
              name: "sintesiitinerario",
              params: {
                itineraryAlreadyExist,
                itineraryCode,
              },
            });
          }
        } else {
          //ERRORE NELLA LUNGHEZZA
        }
      }
    },
  },
};
</script>

<style lang="scss">
.vue2leaflet-map {
  z-index: 1;
}
.scuolaDellInfanzia {
  color: black;
}

.scuolaPrimaria {
  color: #e7d431;
}

.scuolaSecondariaDiPrimoGrado {
  color: orange;
}

.scuolaSecondariaDiSecondoGrado {
  color: darkorange;
}

.universita {
  color: orangered;
}

.perTutti {
  color: #71bd54;
}

.card a {
  color: #000000;
}

.card a:hover,
.card a:focus {
  color: #000000;
}

.img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  /* cover makes the image stretch the width and height of the container */
}

.truncate {
  position: relative;
  max-width: 20rem;
  /* need automatic multi-line height */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  float: left;
  word-wrap: break-word;
}

.truncate.truncated {
  white-space: initial;
  max-width: 20rem;
}

.truncate.truncated .helpicon {
  display: none;
}

.helpicon {
  right: 0;
  top: 0;
  position: absolute;
}

.zoom {
  transition: transform 0.2s;
  /* Animation */
  margin: 0 auto;
  cursor: pointer;
}

.zoom:hover {
  transform: scale(1.03);
}

.containerCard {
  width: 100%;
}

.containerCard div {
  width: 100%;
}

.containerCard .header {
  padding: 2px;
  cursor: pointer;
  font-weight: bold;
}

.containerCard .content {
  display: none;
  padding: 5px;
}

/* .blueButton {
  background-color: cornflowerblue;
  color: white;
} */

html,
body {
  overflow: scroll;
}

.circular {
  animation: rotate 2s linear infinite;
  height: 100px;
  position: relative;
  width: 100px;
}

.loader {
  position: absolute;
  width: 100px;
  height: 100px;
  top: 50%;
  left: 50%;
  padding-top: 5rem;
  transform: translate(-50%, -50%);
}

.filterDiv {
  max-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
}

.border-radius-5 {
  border-radius: 5px;
}

.k-progress-outer-custom {
  margin-right: 0px;
}

.form-check {
  margin-top: 0.35rem;
  padding-left: 0;
}

//Collapse aree
.collapsible {
  cursor: pointer;
}

.content-close {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.4s ease-out;
}
.content-open {
  max-height: 100%;
  overflow: hidden;
  transition: max-height 0.4s ease-out;
}
</style>